<script setup>
import { vElementSize } from '@vueuse/components'

const { t, locale } = useI18n()
const getWidth = ref(0)
const getHeight = ref(0)

function onResize({ width, height }) {
  getWidth.value = width
  getHeight.value = height
}
</script>

<template>
  <!-- eslint-disable -->
  <div class="md:overflow-hidden">
    <div :style="{
        minHeight: `${getHeight}px`,
      }">
      <svg v-element-size="onResize" class="!font-[5px] text-[#6794dc] fill-[#6794dc]" id="Objects" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 458.1 267.6">
      <g>
        <path
          d="M164.3,7.9l-7.7,2-1.6,4.2-1.8-1.1-4.8,2.8,1.9,2-2.7,2.6-7.4,1.5,.7,3.7,4.3,.9-6,1.3,2.2,5.1,8.9,.9-.7,13.6,2.2,2.2-2.9,2.3v2.8h3.8l-2.7,4.7-2.7,1.5,1.8,11.8,2.7,3.9,4,3.2,6.9-13.5,6.2-1.8,4.1-4.5,11.4-4.6-6.3-.8,1.1-4.1,3.2,3.7,2.1,.3v-3.6l-2.9-4.8,3.6,.3,2.2-1.9,1.1-7.1-1.4-2.5,3,.4,.6-2.5-2.2-1.6,10.7-14.3-4.1-2.8-8.9,5.7,3.8-5.7-3.8,1.7,.6-1.7-6.5,.7,11.9-3.5-3-2.5-1.4-.8-7.5,.8,7.2-2.3-8-1.8-3.2,1.8-3.3-.5-3.8,2s2.5,4.7,2.1,5.1-2.9,0-2.9,0l-.7-5.1-1.6,3.8h-2.6c0-.1,1.1-3.8,1.1-3.8Z"
          fill="currentColor"
        />
        <g>
          <polygon
            points="92 145.4 94.9 144.9 96.4 144.4 97.7 144.9 100.6 145.9 101 146.8 102.8 147.4 101.8 148.6 102.2 148.6 104 148.2 105.4 148.6 106.8 147.8 104.5 146.5 101.6 144.9 99.9 144.9 98.9 143.8 97.2 143.8 96.2 143.2 94.4 143.7 92.7 144.3 92 145.4"
            fill="currentColor"
          />
          <polygon points="103.9 151.2 102.9 150.2 100.5 150.7 101.7 151.6 102.8 151.6 103.9 151.2" fill="currentColor" />
          <polygon points="115.7 150.9 115.7 151.6 118.1 151.6 118.4 150.2 115.7 150.9" fill="currentColor" />
          <polygon points="124.8 161.2 123.4 161.2 123.4 162.9 124.1 162.9 124.8 161.2" fill="currentColor" />
          <g>
            <polygon points="101 137.8 101.4 138.6 102.6 137.8 102.6 137.2 101 137.8" fill="currentColor" />
            <polygon
              points="102.2 140.2 101.5 141.2 102.2 141.6 102.2 142.9 103 142.5 102.6 141.6 102.2 140.2"
              fill="currentColor"
            />
            <polygon points="103.4 137.5 103 137.9 103 139.5 103.9 138.9 103.4 137.5" fill="currentColor" />
            <polygon points="105 141 105 142.2 105.8 142.2 105 141" fill="currentColor" />
            <rect x="106.8" y="143.7" width=".7" height="1.2" fill="currentColor" />
            <polygon points="108.6 146.3 107.5 146.3 107.2 147 108.3 147 108.6 146.3" fill="currentColor" />
            <polygon points="105.8 142.9 105 142.9 106.1 144.3 105.8 142.9" fill="currentColor" />
          </g>
          <polygon points="126.8 157.9 126.2 157.9 126.8 158.7 127.2 158.3 126.8 157.9" fill="currentColor" />
          <g>
            <rect x="123.4" y="159.1" width=".7" height=".9" fill="currentColor" />
            <polygon points="124.8 156.9 124.1 157.5 124.5 157.9 124.8 156.9" fill="currentColor" />
            <polygon points="123.7 155.6 124.5 156.6 124.8 156.3 124.5 155.6 123.7 155.6" fill="currentColor" />
          </g>
          <g>
            <polygon points="123.4 153.7 123.4 154.5 124.1 154.1 123.7 153.4 123.4 153.7" fill="currentColor" />
            <polygon points="124.8 153 124.3 153.4 124.5 153.9 124.8 153" fill="currentColor" />
          </g>
          <g>
            <polygon points="122.1 150.9 121.4 151.6 122.1 152.2 122.1 150.9" fill="currentColor" />
            <polygon points="123.7 151.2 122.9 151.6 123.4 152.2 123.7 151.2" fill="currentColor" />
          </g>
          <polygon
            points="109.6 148.6 108.1 148.2 107.7 148.6 108.7 149.2 109.2 150.2 107.8 150.2 106.1 150.2 106.8 151.2 109.5 151.2 110.3 148.3 109.6 148.6"
            fill="currentColor"
          />
          <polygon
            points="113.1 149.2 112.2 148.6 110.5 148.2 110.3 148.3 109.5 151.2 109.6 151.2 110.2 152.2 111.5 150.9 114.5 150.9 114.9 150.2 113.1 149.2"
            fill="currentColor"
          />
          <polygon
            points="92.9 161.1 94 155.4 93.7 155.3 87.4 159 89.1 160.5 89.4 161.2 93 161.2 92.9 161.1"
            fill="currentColor"
          />
          <polygon points="93 161.2 89.4 161.2 90.3 163.4 93.3 165.2 93.9 165.4 94.8 163.3 93 161.2" fill="currentColor" />
          <polygon
            points="84 153.9 83 151.6 85.2 151.7 87.8 151.1 88 150.6 89.9 146 88.9 145.3 84.8 146.5 82.5 150.6 78.1 150.4 74.6 146.4 75.8 139.5 73.4 138.5 71 132.9 68.2 133.9 64.6 129.6 58.4 129.6 52.9 127 49.7 126.6 50.5 129.9 52.5 135 50.7 135 53.5 137.4 55.3 140.9 57.9 143.9 58.6 142.5 56.5 139.4 55.3 135.5 52.9 132.3 52.9 129.2 55.3 129.6 56.8 135 59.7 137.4 63.4 145.3 62.4 148 71.3 153.3 75.9 155.2 78.2 154 81 156.2 81.9 153.9 84 153.9"
            fill="currentColor"
          />
          <polygon
            points="85.2 151.7 83 151.6 84 153.9 81.9 153.9 81 156.2 82.8 157.6 84.2 157.9 86 155.9 85.5 151.6 85.2 151.7"
            fill="6794dc"
          />
          <polygon points="86.7 155 87.8 151.1 85.5 151.6 86 155.9 87.1 154.9 86.7 155" fill="6794dc" />
          <polygon points="84.2 157.9 86.6 158.3 87.4 159 89.2 158 85.6 156.4 84.2 157.9" fill="6794dc" />
          <polygon points="90.2 154 87.1 154.9 85.6 156.4 89.2 158 93.7 155.3 90.2 154" fill="6794dc" />
        </g>
        <g>
          <polygon
            points="112.2 174.9 115.7 174.5 114.9 168.1 108.6 166.4 108.2 162 110.5 159.6 110 159.1 103.8 162 102.4 164.9 99.4 163 95.3 163.8 94.8 163.3 93.9 165.4 97 166.7 97.9 165.5 99.4 164 100.3 165.3 101.7 170.3 99 175 111.8 182.5 112.2 174.9"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="104.6 178.3 99 175 98.8 175.2 96.4 179.5 97.6 181.8 96.8 182.5 99.3 184.4 104.6 178.3"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="111.1 190.7 107.5 189.9 106.7 186.2 109.5 183.3 111.7 183.3 111.6 182.4 104.6 178.3 99.3 184.4 96.8 182.5 95.5 183.6 99 188.1 103.2 196.9 107.8 200.4 111.5 203.7 113.3 202.2 113.3 193.4 111.1 190.7"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="120.5 173.7 119.4 171.2 124.8 169.9 124.1 168.3 125.7 165.3 121.8 162.6 122.3 161.2 112.6 161.2 110.5 159.6 108.2 162 108.6 166.4 114.9 168.1 115.7 174.5 115.7 174.5 117.7 176.2 120.5 173.7"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="126.2 174.2 127.5 175.6 130.8 174.1 128.7 170.2 129.8 168.6 129.6 168.6 125.9 165.5 125.7 165.3 124.1 168.3 124.8 169.9 124.6 170 126.2 171.3 126.2 174.2"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="131.5 173.1 133.7 173.8 134.2 171.6 133.4 169.8 134.2 168.6 129.8 168.6 128.7 170.2 130.8 174.1 130.7 174.1 131.5 174.4 131.5 173.1"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="135 174.4 137 171.8 134.6 168.6 134.2 168.6 133.4 169.8 134.2 171.6 133.7 173.8 133.5 173.7 134 174.4 135 174.4"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="114.6 206.2 116.3 210.3 117.9 208.7 123.1 208.7 123.9 205.5 127.3 204.6 128.9 205.5 130 203.7 128.4 200.2 126 199.8 125.3 196.6 119.4 194.2 118.3 191 113.2 193.3 113.3 193.4 113.3 202.2 113.1 202.3 114.5 204.4 114.6 206.2"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="117.7 260.6 117 257.4 115.6 257.9 115.3 254.7 116.2 254.1 116 245.5 114.4 240.7 114.8 235.2 114.4 230.3 115.1 226.7 113.9 223 114.6 218.7 115.7 216.3 115.4 212.8 117.2 210.3 116.8 209.8 116.3 210.3 114.6 206.2 114.5 204.4 113.1 202.3 111.5 203.7 111.8 204 111.9 222 110.9 233.9 111.5 239.1 113.3 241.3 112.9 245.6 112.3 248.6 110.9 250.1 112.2 252.6 113.5 258.7 117.1 264.3 121.9 267.5 125.6 267.5 126.3 266.7 122.1 260.6 117.7 260.6"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="130 213.3 130 215 129.1 216.7 132.9 216.7 134.9 211.1 133.2 211.4 132.5 208.6 130 208.8 129 205.3 128.9 205.5 127.3 204.6 123.9 205.5 123.1 208.6 125.4 211.2 130 213.3"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="130 226.5 130.7 227.4 136.4 229.1 138.3 225.7 131.1 220.8 130 226.5" fill="6794dc"
            stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="135.9 216 135.9 214.3 134.1 213.2 132.9 216.7 129.1 216.7 130 215 130 213.3 125.4 211.2 123.1 208.6 123.1 208.7 117.9 208.7 116.8 209.8 117.2 210.3 115.4 212.8 115.7 216.3 114.6 218.7 113.9 223 115.1 226.7 114.4 230.3 114.8 235.2 114.4 240.7 116 245.5 116.2 254.1 115.3 254.7 115.6 257.9 117 257.4 117.7 260.6 122.1 260.6 126.3 266.7 127.6 265.4 121 258.1 124.3 250.7 121 248.8 123.4 246.6 125.2 241.3 123 239.1 126.3 239.8 126.3 235.7 132.5 234.5 133.3 230.8 130.3 227.3 130.7 227.4 130 226.5 131.1 220.8 131.4 221 132.2 219.3 135.9 216"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="159.6 184.2 150.1 180.3 143.1 178.5 138.8 176.6 139.2 174.7 137 171.8 135 174.4 134 174.4 133.5 173.7 131.5 173.1 131.5 174.4 130.7 174.1 127.5 175.6 126.2 174.2 126.2 171.3 124.6 170 119.4 171.2 120.5 173.7 117.7 176.2 115.7 174.5 112.2 174.9 111.8 182.5 111.6 182.4 111.7 183.3 109.5 183.3 106.7 186.2 107.5 189.9 111.1 190.7 113.2 193.3 118.3 191 119.4 194.2 125.3 196.6 126 199.8 128.4 200.2 130 203.7 129 205.3 130 208.8 132.5 208.6 133.2 211.4 134.9 211.1 134.1 213.2 135.9 214.3 135.9 216 132.2 219.3 131.4 221 138.3 225.7 143 217.4 143 214.3 152 209.5 155.1 202 155.1 195 161.1 187.5 159.6 184.2"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
        </g>
        <g>
          <polygon
            points="44.5 65.3 41.5 66.9 38.1 62.4 53.9 34.1 53.8 33.9 51.6 31.3 46.2 28 44.7 28 43.7 24.9 40.7 22.4 33.8 23.9 27.2 27.8 24.8 26.9 23 29.1 23.7 34.8 26.1 37.5 23 38.7 20.8 37.8 22.3 36.4 20.8 35.3 14.3 37.2 14.9 42.3 16.9 43.1 21.6 42.3 19.8 46.3 13.6 47.3 9.1 51 9.1 56.5 11.8 57 10.9 61.2 14.4 62.3 15.8 62.3 10.3 67.5 .3 71.5 1.5 72.1 6.1 71.3 17.1 65.3 21.9 62.9 20.2 61 24.1 58.8 27.1 57.9 23.9 62.7 28.2 61.2 29.6 58.5 33.4 60.9 39.5 65.3 41.9 72.8 44.1 79.8 46.6 77.9 44.5 65.3"
            fill="6794dc" stroke="#fff" stroke-width=".2"
          />
          <g>
            <polygon
              points="40.1 79.9 42.8 80.5 41.5 86 40.1 84 40.1 79.9" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <path
              d="M43.9,88.9l-.6,1.3,2.7,3.1,1.5,.8c.5-.8-2.1-4-2.1-4l-1.6-1.3Z" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="74.8 31.3 77.4 35.2 83.7 30.6 89.6 29.9 88.7 25.1 81.5 23.9 80.7 26.6 74.8 31.3"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <path
              d="M89.6,31.3h-4.7l-3.3,2.6s-.3,.8,0,1.3c.3,.4,3.9,.7,3.9,.7l-4.9,.9v1.9h4.5l1.7,2.9-6.2-1.9-.7,1.9,2.2,1.8v3.3h4l4.7-2.6,1.2,3.3h3.7l-1-2.5,2.6,1v-2.1l-1.5-3.8,2.1-6.1-1.8-2.6-3,6.8,.6-4.9-4.1-1.8Z"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <path
              d="M107.8,31.3c-.4,.2-3.7,1.4-3.7,1.4,0,0-4.1,2.2-3.8,2.5,.3,.3,3,7.1,3,7.1l3.2-2.9,1.4-4.2v-3.9Z"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="115.5 33.9 110.8 32.6 107.8 37.6 108.6 39.3 110.5 36.8 111.6 38.3 115.5 33.9"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <path
              d="M96.5,18.1c-.4-.1-6.3,4.5-5.9,4.3,.4-.3,2.9,4.2,2.9,4.2l6.7-.9,1.8,.9,3.2-4.2h-2.9s1.1-4.2,1.1-4.2h-1.9l-1.8,5-1.8-.7-1.4-4.3Z"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="97.9 13.2 95.3 13.2 88.1 16.3 89.6 19.2 96.1 17 97.9 13.2" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="105.2 13.2 100.2 12.5 100.8 16.2 103.4 16.2 105.2 13.2" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="107.8 9.6 107.2 13.2 103.4 11.4 107.8 9.6" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="106.8 21.1 106.8 25.3 109.1 25.3 107.8 28.7 110 28.7 113.7 22.4 110.2 21.1 110.2 23.9 107.8 23.1 106.8 21.1"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="113.7 9.6 110.8 14.4 113.7 14.4 113 19.2 115.5 19.2 117.4 13.2 113.7 9.6"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="120.6 17 118.5 14.4 117.4 18.1 119 19.2 120.6 17" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="120.6 21.1 116.7 19.2 116.7 21.1 119 22.4 120.6 21.1" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="114.9 21.1 114.9 24.9 117.4 25.6 116.7 28.7 115.5 31.3 118.6 33.3 125.1 34.5 128.4 33.9 128.4 29.9 124.7 29.5 118.6 27.8 120.1 24.9 117.4 23.1 114.9 21.1"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="114.9 27.8 113.7 31.3 111.6 29.5 113.3 26.6 114.9 27.8" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="101.4 45.6 102.7 49.3 101.4 50.6 98 48.1 101.4 45.6" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="121.1 36 117.4 36 112.3 42.3 111.6 46.3 116.7 48.8 121.1 49.9 122.8 47.4 124.3 51.9 127.1 56.2 123.9 60.7 123 62.8 119 61.6 117.4 65.3 121.1 65.3 124 66.9 125.5 69.8 130 72.8 128.4 68.2 132 70.6 133.2 67.6 130.4 62 132.2 60.7 134.7 66.1 139 60.6 132.8 55.2 135.3 53.2 133.1 48.1 129.8 44.5 128.4 42.3 123.4 42.3 124.4 36.8 120.6 37.6 119 39.3 117.4 44.8 116.7 42.3 118.6 38.1 121.1 36"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="125.3 36.8 125.3 40.8 129.2 40.8 128.4 37.8 125.3 36.8" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="125.3 55.7 123.7 54.4 121.1 55.7 121.7 58.3 125.3 55.7" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="110.2 60.3 107.8 63.8 106.8 66 108.5 67.5 111.6 65.3 113.7 66.7 114.9 63.9 110.2 60.3"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <path
              d="M121.7,26.6l3.6,1.2,3.9,.8,3.8-2.1-.7-1.7,4.3-1.8,3.6-3.9-1.2-2.3h4.7l4.1-3.8,6.2-1.8s.1-2.2,0-1.8c-.1,.4,4.5-1.9,4.5-1.9l-1.1-3-4.4-2.9-6.5-1.6-8.7,1.5-6.2,2.1-.5,4.9,5.4,2.7-.7,1.1-5.1-2.9-.8-5h-1.5l-3.8,4.1-1.3,4.4,2.1,1.2h-2.8l-.3,4.8h3.1l2,1-4.1,3.7-1.5,2.7Z"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="97.9 30.5 98.8 33.3 101.3 31.9 101.3 30.5 97.9 30.5" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <path
              d="M138.1,95.6l-1.5,.5-1.9,2.7-2.5,3.8,.7,.6h1.5l2.4-.4,1.3,.4-2.2,1.4,1,.6,2.1-2-.6,1.2,1.6,.8s1.2-2.7,1-2.7-1.5-.5-1.5-.5l.4-2.7h-3.3v-1.1l1.5-2.7Z"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="94.6 95.6 95.7 95.6 95.7 97.4 94.2 97 94.6 95.6" fill="6794dc" stroke="#fff"
              stroke-width=".2"
            />
            <path
              d="M137.2,90.8l-2.6-1.9-3-3.5,1.6-1.3-3-8.3-2.7,4.9-3.3-1.2,.5-5.1-2.1-1.5-1-2.6-5.6-1.2-1.4,6.7-2.2,3.5,1.6,4.1-1.4,2.4-3.8,1.3v6.3c.1,0-2.7,.8-2.7,.8l-1.2-2.8,1.5-4.9-3.8-.7-5.5-5.3-3.2,1.1,1-5.8-1.8-.2,7.1-8.9,3.7-2.6,4.7-2.5,1.8-2.3,4.9-1.4,1.5-1.9-.6-3h1.6l1-1.9-3.7-2.2-1.4,2.3-3.4,4.3-.5-2.9,.4-3.7-2.3,2.7-.5-2.7,1.4-3.3-.7-5.5-4,2.3s-1.8,3.6-1.4,3.9c.4,.3,2.2,2.2,2.2,2.2l-1.8,3.3-2.5,2.7-1.2-4.4-2.6,1.8-4.5-1.1-1.2-3.6h-3.3l-1.4,4-1.4-2.3h-4.3c0,.1-1.8-1.5-1.8-1.5l2.2-.4-.7-3.3-5.8-4-2.5,1.1-2.1-1.1v-4.9l-11.8,3.4-4.4-4-15.8,28.3,3.4,4.5,3.1-1.6,2.1,12.6-2.5,2h0s1.6,7.7,1.6,7.7l4,6.7,37.6,3.6,4.7,2.3,3.3-1.7,1.4,.4,1.9,1.7,.3,2.5,4.3,1.6,1.4,2.2-1.2,.9-1.5-1.4-.4,3.2h-.9l-.4,2.2,1.3-1,1.1,.3,1.4-.3,.2,.2,.5-.8-.7-1,2.5-.6,.8,.5,.4-.8,1-.4,.3,1.1,6.2-2.2,3.7-3h2.2v4l.6-.3,.5,2.7,3.2-1.9,5.6-2.4-.7-1.3-2.5,1.3-2.9-.6-.8-2.9,2.5-1.2-1.6-2-7.1,4.1,4.2-4.1,2.3-1.7,7.1,.5,4.3-1.6,2.2-2.1-.8-3.4Zm-62.7-17.9l-.8,1.4-2.7-.4v-.6h1.9c0,.1,.8-1.2,.8-1.2l2-.5,2.3,1.3h-3.6Zm7.2,2.1c.1,0,1.4,0,1.4,0l-1.4,2.7s-.6-.2-.7-.3c0-.1,.5-2.3,.7-2.3Zm0,5v-1.4l1.8-1.9,1.1,1.4-1.9,.4v1.5l-2,1.5-.3-1,1.3-.6Zm.8,10.6l-1,1.6-.7-.4,1-2.1h-1.3v-.8h2v1.7Zm.2,4.4c-.1,0,0-3,0-3l.6-.4-.2,1.7,.4,1.3s-.7,.3-.8,.3Zm2.2,0v-3.6h-.8l-.5-1.6,.5-1h-1.4l-1.6-1.4,.5-1.5h1.5l-.3,1.6,.6,.7,.8-1.4,1.2,.5v3.7l.5,3.3-1.1,.7Zm26.7,5.4l1.1-.7,.6,1.3-1.7-.6Zm4.5-4.5l-2,.9v-.9l2-.8v.8Zm5.4-5.4l-1.1-.9,1-1.5,1.2,.8-1.1,1.6Zm7.9,.6h-2.4l.3,2.4-1.5-2.9,.8-.9,2.8,.3v1.1Z"
              fill="6794dc" stroke="#fff" stroke-width=".2"
            />
          </g>
        </g>
        <g>
          <polygon
            points="388.2 78.2 387 80.3 388.2 84.2 390 85.9 391.4 91.9 392.8 95.2 393.7 97.8 394.1 95.9 395.6 96.9 395.6 95.5 393.3 93.9 392.7 89.9 394.9 90.8 393.1 88 390.6 83.9 389.9 81.9 388.2 78.2"
            fill="6794dc"
          />
          <polygon points="400.1 100 401.1 100 403.2 97.8 403.2 96.5 401 97.8 400.1 100" fill="6794dc" />
          <polygon points="404 97.1 405.3 95.1 404.6 94.5 403.6 97.1 404 97.1" fill="6794dc" />
          <polygon
            points="223.4 36.8 225.2 28.8 227 28.1 223.4 24.4 221.9 23.1 221.1 23.6 221.5 27.6 220.2 24.2 219.1 23.8 216.7 25.5 219.1 29.4 219.8 30.5 220.9 29.9 220.5 28.3 223.3 29.9 219.8 31.2 221.3 34.3 223.4 36.8"
            fill="6794dc"
          />
          <polygon
            points="227.7 28.7 226.1 28.7 226.9 30.4 227 33.4 228.8 32.2 228.8 33.9 230.7 31.3 228.4 30.8 228.4 29.6 227 29.9 227.7 28.7"
            fill="6794dc"
          />
          <polygon
            points="226.1 21.1 224.1 21.1 223 23.1 224.6 24.4 226.5 23.9 224.8 25.1 226.5 26.1 228.4 26.6 230.7 25.6 231.1 22.2 228.4 21.1 227.1 22.6 226.1 22.2 226.1 21.1"
            fill="6794dc"
          />
          <polygon points="245.3 18.2 247.7 19.2 248.1 17 249.1 17 248.5 15.8 247.2 15.8 245.3 18.2" fill="6794dc" />
          <polygon
            points="248.4 20.3 249.8 21.1 250.6 19.2 251.9 17.5 250.1 15.8 249.1 17.5 248.4 20.3"
            fill="6794dc"
          />
          <polygon
            points="253.5 19.2 255.4 18.5 256.8 19.2 257.9 18.8 258.9 17.5 257.1 16.5 255.7 17.5 253.1 17 253.5 19.2"
            fill="6794dc"
          />
          <polygon
            points="260.1 14.1 258.3 14.8 258.9 17.5 260.6 16.5 259.5 15.4 260.6 14.8 260.1 14.1"
            fill="6794dc"
          />
          <polygon points="261.6 11.2 260.1 11.2 260.1 13 261.6 14.7 262.5 13 261.6 11.2" fill="6794dc" />
          <polygon
            points="256 11.6 254.4 11.6 254.4 13 253.4 14.1 253.4 15.8 254.7 16.5 256 16.5 257.1 14.7 255.3 13 256 11.6"
            fill="6794dc"
          />
          <polygon points="260.1 18.5 259.5 17.8 258.3 19.2 259.2 19.8 260.1 18.5" fill="6794dc" />
          <polygon points="251.9 19.8 251 19.8 251.9 21.1 253.1 20.5 251.9 19.8" fill="6794dc" />
          <polygon points="256 9.9 254.4 9.9 255.2 11.2 256 11.2 256 9.9" fill="6794dc" />
          <polygon points="287.1 4.6 285.5 8 286.3 10.6 289.5 11.2 291.5 8.6 287.1 4.6" fill="6794dc" />
          <polygon
            points="292.8 8.8 290.3 11.6 290.3 13.4 292.8 14.4 296.5 14.7 297.5 13.5 295.1 9.9 292.8 8.8"
            fill="6794dc"
          />
          <polygon
            points="298.3 10.6 298.3 13 299.4 17.5 300.3 17.8 302 15.8 303.6 14.2 303 13 298.3 10.6"
            fill="6794dc"
          />
          <polygon points="356.2 10.6 356.2 12.5 352.9 12.5 351.1 11.2 352.7 10.6 356.2 10.6" fill="6794dc" />
          <polygon points="351.1 18.5 350.2 21.1 354.2 21.1 354.2 19.2 351.1 18.5" fill="6794dc" />
          <polygon
            points="349.1 11.2 344.2 10.6 344.2 13 341.1 10.6 340 13 342.1 15.8 345.6 17.5 348.4 14.7 350.2 13.5 349.1 11.2"
            fill="6794dc"
          />
          <path
            d="M272.5,28.7l1.6,2.6-5.1,4.4-2.5,4.7-1.4,5.7,1.8,3.6,2.7,1.2-1.3,1.1-3.7-.6-3.4-3,1.2-1.6v-1.9l.5-5.6-.5-2.1,2.1-1.1,.5-2.3s3.9-2,4-2,1.8-2,1.8-2l1.6-1.3Z"
            fill="6794dc"
          />
          <polygon points="262.5 55.9 260.1 55.5 260.1 56.9 260.6 58 262.5 58 262.5 55.9" fill="6794dc" />
          <polygon points="280.5 39.5 281.5 41.2 279.7 41.2 279 40.4 280.5 39.5" fill="6794dc" />
          <polygon points="321.9 26 320 26.6 320 28 321.9 28 321.9 26" fill="6794dc" />
          <path
            d="M411.2,37.4l1-.8,1.7,.4,.6-4.1-2.5-2.4,.7-1.3,1,1.6,1.4,.3,.3-1.4h1.6c0,0,1,1.1,1,1.1l3.8-1-2-3.4-1.5-.9,1.8-2-1.4-2.3-3.2-.5-1.7,1.4,1.8,2.4h-1.6l-1.9-2.7-7.8-1-6.4-1-6.5,1.4,.8,1.6,2.3,1.8-.5,1.6-1.5-1-1.7-.6-1.3-1.4-.8,1.8-5.2,1.2,.2,1.7-1.6-1.1-2.1,.5-1-2.7-3-1.4-4.2,2-2.6,.8-.2-1-1.3-.6-.9,.8-2.3-1.4,.2-1.4-3.6,.4-.5,3-.5-2.3-1.7,.7v-1.4c0,0-5.8,.4-5.8,.4l1.7,1.4-1.4,1.2,1.4,.4,1.2,2h-1.5c0,.1,0,2,0,2l-2.7-1.1-1.2,.5,.2,.8h-2.1c0,0-1.2-1.1-1.2-1.1l1,4.5-3.4-1.8-2.7-1.5,1.6-.3-1-1.5-1,.2v-1.4c0,0-3.8-1.6-3.8-1.6l-2.8,.3-1,.6,1.3,2.1-3.5,1h-2.5c0-.1,0-1.9,0-1.9l-5.4,1.1-2,.8-2.1-.9v2.1l-2.3,3.6-.3-2.3,1.7-5.6,.6-4.2-4.1-2.9-2.1-.9-2.3,1.1-.8,1.9-.8-3-2.9,.9,.4-2.1-2.3-.6-1,3.4,2.5,3-3,.3,1.8,2.2-1.8-1-1.5,1.5-.8-.6-2.7,.7,1.2,.6-3.6,2.5-1.4,2.8v2c.1,0,2.4,1.1,2.4,1.1l-1,.7-5.4,1.9,1.6,3.3,2.7,1.4,1.1,.6,.5,.3,1,2.4-1.2,1.2-.6-3.5h-2.3l-3.4-1.9-.9,1.2,.6,1.3-1.9-.6,1.1,2.2,2.7,.8-4.1-.5-1.5-4.7h-.9c0,0,1,2.7,1,2.7l-1.1,1,.7,1.9,1.9,1.4,.8,3.6,.9,.8,2-1,2.9,1.6v1.2c0,0-1.2-.7-1.2-.7l-1.4-1.3-1.6,1.4,1.1,2.7-.8,2.5-.9,1.2-1.3-.5,1-5.6-1.9-1.9-1.8-5-1.3-1.1-.5-4.3-3.8-.3v4.3c.1,0-.9,2.1-.9,2.1l2.3,4.3,1.1,.2,1.8,1.5-.2,2.1-3.6-2.3-3.8-1.4h-2.4c0,0-.3,1.1-.3,1.1l1,1.8-1.1,1.2-.9-1.2-3.7,1.3-.5,1h-1.4c0,0-.1-1.5-.1-1.5l-4.7,3.4-.7,.6-.2,1.9-1.7,.2-1.2-1.6,1.4-1.1-1.4-1.6-2.3-.2,.8,3.9,1,.3v2.4c.1,0-2.2-.8-2.2-.8l-2.5,2.6,1.4,1.8-.9,1-3.4-1.6-.5,1.3,2.2,1-.9,1-2.4-1.2-1.3-2.5,.2-1.9-3.4-2.1,.5-.3,3.6,1.6,2.9,.9,2.8-1.3,.3-2.2-6.8-4.6-2.7,.4-2.3-.8-.9-.3-1.7,1.7v-.2c0,0-.5,1.3-.5,1.3l2.1,2.8-.6,1.4,1.5,3.3v1.8l1.2,3.9,.9,1.2-2.9,5,1.5,1.3-1.7,1.4,.5,3.2,.6,3.3-1.3,1.2-1.1,2.5-2.6,1.3h0s.7,2,.7,2l-.6,.9v.7c.1,0,1.5,.2,1.5,.2l1.6-.5,2.7,.6h3.5l.2-.9,1.4-.2,.3-.5h2l.2,1.2,.7,.7,.8-.2,1.2,2,1.9-.5,.6,.7,2.9,.7,.3,.8-.6,.3,.3,1.5v.8c-.1,0-1.2,.3-1.2,.3l-.3,1,.6-.2-.4,1.1-.8,2.1h-.9c0,0,0,.6,0,.6l1.6,.9,2.7,2,2.1,1.6-.2,1.2,2.3,.4,.8,.7,1.9-.2,.7-.6,1.9,.6-.6-1.1,.4-.4,1.5,1.1,1.5-1.1-2.1-3.2-1.5-1,.7-2.4,1.3-.4,1-.8-1.3-1-2.6-2.5v-3c-.1,0,.6-1,.6-1l1.7,1.3v-1.6l2.1-2.2h1.9l3.4,1.6,3.3-.7,2.4,.7,2.7-.3v-1.3l-1.6-1.3,.5-2.1h1.1l-1.6-1.4,1.6-.5,6.3-2.5,1.6-1.3,2.5,.3,.4,1.9,4.8,1,2.5-1.9,6.1,6.9h2.1c0,.1,2.1-.6,2.1-.6l2.3,2.1,1.4,.5h1.4c0-.1,.7,.9,.7,.9l.4-.4,.3,.4,.9-.9,2-2.4,2.8-.7,3.1,1.7,3.7-.4-1.2-2.9,1.2-1.6,4.5,.8,1.9,2.3,4.1-.5,3.7,1.6,5.4-.8,2.1-1.9,3.1,.8v-.2s1.7,.1,1.7,.1l1.1-1.3-.3-2.2,.3-1.6v-1.4l-1.2-.3,.3-1.2,2.5-1h2.4l2.5,.8,2.4,3.4,2,2.9,1.9,.4,3.1,1.2,.7,2.3,1.8,.3,.7-1.4,1.8-.9,1,1.6-.3,1.3,.3,4.8-1.9-.3-.8,.8,.8,3.6-.6,.9,.6,.4,.3-.4,.6-1.5h1c0,0,.5,1,.5,1l1.5-.3,2.3-4.7,1.4-5.2,.6-3.8-1.2-4-.5-3.6-.5-1.2-.5-2.1-3.8-1.8-.5,1.5-1-.6-1,.4-.8-2.1h-2.2c0,0,2.5-6.7,2.5-6.7l1-4.3,.8-2.1,5.3-1.6h2.1c0,0,.3-1.8,.3-1.8,0,0,3.2,.5,3.4,.5,.2,0-.3,1.1-.3,1.1l.4,.6,3.9-2.1-.6-.8h-1.1c0-.1,.4-4.1,.4-4.1v-2.3c-.1,0,1.7-1.2,1.7-1.2l2.1-.7,.3,2.5,1.9,.9,1.2-4-1.3-2.7,2.5-.5,.9,5.8-1.5,1.4v5.7c-.1,0-.4,2.5-.4,2.5l-1.4,1.2,.5,1.9v3.5c-.1,0,4.9,8.7,4.9,8.7l1.9,3.4,1.6-1.4-.5-3.6,1.3-1-.8-2.7,1.4-1.5-1.6-4.9h1.6c0-.1-1.2-1.8-1.2-1.8h-1v-2.5c0,0-1.2-.4-1.2-.4l-.3,1-1-1.1v-3.8c0,0-.8-2.4-.8-2.4l2.3-1.9,1,1.6,1-2.7,1.7-.4,2.1,1.6v-1.3l.6-4.5,3.1-4.9h2.1v-1.7l-7-5h-1.3Zm-166.2,42.7l-2.2-2.2,1-2.3,2.7,3-1.5,1.4Zm4.7-2.2l-2.1-2.3,.6-1.9,.8,.5,.8,1.5,.6,1.7-.8,.4Zm4.7,6.6l-2.3-1.8,.8-1.1,2,1.6-.5,1.3Zm88.2,4.1v2l-3.2,.9v-.9l1.8-.8,1-2.7,1.3-2.5-1.3-3.5h2l.8,5.1-2.5,2.5Z"
            fill="6794dc"
          />
        </g>
        <g>
          <polygon points="410.1 157 409.5 156.5 408.8 157.4 409.5 158.5 410.1 157" fill="6794dc" />
          <g>
            <polygon points="429.3 187.6 429.3 188 430.8 189.7 431.4 189 429.3 187.6" fill="6794dc" />
            <polygon points="430.8 190.7 430.3 191.4 432.2 192.3 432.5 191.5 430.8 190.7" fill="6794dc" />
            <polygon points="432.5 189 432 189 433.2 191.5 434 191 432.5 189" fill="6794dc" />
            <polygon points="433 191.9 433 192.7 434.5 193.6 434.5 192.7 433 191.9" fill="6794dc" />
          </g>
          <g>
            <polygon points="439.8 198.9 439 199.3 439.8 200.9 440.7 200.4 439.8 198.9" fill="6794dc" />
            <polygon points="440.7 200.9 440.4 202 441.3 202 440.7 200.9" fill="6794dc" />
            <polygon points="442 203.3 441.3 203.3 441.7 204.6 442.4 204.6 442 203.3" fill="6794dc" />
          </g>
          <polygon points="455.8 203.3 454.4 203.9 453.9 205 455.8 205.3 456.1 204.3 455.8 203.3" fill="6794dc" />
          <polygon points="458.1 201.4 456.1 202.2 456.1 203 458.1 203 458.1 201.4" fill="6794dc" />
          <polygon
            points="435.5 207.8 435.1 208.4 436.4 210.6 438.5 212 439 211.1 437 209.3 435.5 207.8"
            fill="6794dc"
          />
          <g>
            <polygon
              points="443.1 235.4 442.2 235.8 442.7 238.8 443.1 241.7 442.7 245.5 441 245.9 441 247 442.4 248.6 441 251 441.6 252.2 445.6 247.7 447 246.7 448.6 243.8 447.9 243.2 446.7 244.2 445.4 243.1 445.3 240.4 444 240.7 444.8 238 443.1 235.4"
              fill="6794dc"
            />
            <polygon
              points="438.2 249.2 440.1 251.7 439.6 253.3 436.9 255.7 436.9 257.1 434.3 257.6 432.3 260.7 429.6 263.1 427.8 262.2 426.2 261.5 428.3 258 431.9 255.8 435.2 253.4 438.2 249.2"
              fill="6794dc"
            />
            <polygon points="426.8 262.5 428.1 263.8 426.2 264.6 426.8 262.5" fill="6794dc" />
          </g>
          <g>
            <path d="M400.6,245.5c.2,0,2.4,1.8,2.4,1.8l2.5-.9-.7,2.8-1.8,2.1-1.8,1-.7-1.4v-5.4Z" fill="6794dc" />
            <path
              d="M407.2,193.2h-1l-1,4.1-.7,4.9-1.4,1.3-2-1.3-3.8-2.4-.5-1.5,2-3.3-3.3-.4-2.7-1v1.3l-2.4,.3-2.3,2.5v1.7l-1.6-.5-1.9-1.4-3,2-1.6,2-.5,1.5-1.3-1.5-1.2,1.5v1.3l-1.4,2.1-8.4,2.2-2.3,1.3-1,4.4,.5,2.2-.5,.7,.5,4,.7,5.3s-1.9,3-1.7,3.1c.2,0,1.2,1.7,1.2,1.7l2.6,.7,3.6-1.9h3.8l1.7-1.6h1.8c0-.1,.6-1.2,.6-1.2h2.4l2.2-.8,4.2,.4,2.3,1,1.5,4.9,3.6-3.7-1.9,4.3,2.3-.6-.7,1.9,1.4-.3v3.4l.6,1.7,3.7,2.4,2-1.6,1.2,2.3,3.4-2.3h2.1c0,0,1-1.4,1-1.4l1-3.4,5.1-7,2.8-7.6-1-5.7-4.7-8.3-2.5-2.3-1-6-1.5-.4-1.2-4.9Z"
              fill="6794dc"
            />
            <polygon points="389.5 193.2 389.5 194.3 390.8 194.6 391.6 193.6 389.5 193.2" fill="6794dc" />
            <polygon points="392.1 234.9 394 234.3 394.6 235.4 392.5 235.4 392.1 234.9" fill="6794dc" />
            <polygon
              points="385.7 189.7 385.4 189 382.9 189.4 381.8 190.1 383.1 190.7 383.2 190.6 385.7 189.7"
              fill="6794dc"
            />
          </g>
          <g>
            <polygon
              points="415.2 184.6 415.2 185.6 417.6 186.4 419.6 186.4 421.1 184.6 421.1 182.9 420.1 182.9 419.1 185.2 417.3 185.2 415.2 184.6"
              fill="6794dc"
            />
            <polygon
              points="418.7 180.7 418.7 181.4 420.7 182.2 421.9 184.2 422.3 184.2 421.1 181.7 418.7 180.7"
              fill="6794dc"
            />
            <polygon points="424.2 184.7 424.2 185.9 425.1 187.1 426.2 186.4 424.2 184.7" fill="6794dc" />
            <polygon
              points="415.9 190.1 413.4 187 414.5 186.8 414.4 185.6 411.6 184.6 411.9 183.3 405.2 180.7 404.9 190.5 405.1 190.7 407.8 191.1 408.4 188.5 410.1 188.1 412.1 189.3 413.9 191.9 418.2 192.7 418.2 191.7 415.9 190.1"
              fill="6794dc"
            />
          </g>
          <g>
            <path
              d="M344.4,169.7l-3.1-.8v1l1.5,1.8,2.9,2.8s2.7,4.7,2.7,4.9c0,.2,1.1,1.9,1.1,1.9l4.5,4.3h1.9l.7-3.8-1.9-1.2-.5-1.6-1.4-.5,.5-1.1-.8-.8-2.3-1.6-3-2.7-2.7-2.4Z"
              fill="6794dc"
            />
            <path
              d="M357,185.6l-1.9,1.4,4.2,1.4,4.7,.7,2.9,.4h2.6l1.5,.8,2.7-.3s-.1,1.2,0,1.2,2.9,1.1,2.9,1.1v-1.5l-2.3-.5,.5-.6,1.9,.3,3-.3v-1.1l-1.6,.7-1.8-.3-2.5,.3-2.8-.3h-2.1l-1.4-.5-2.2-1.4-2.5-1-.3,1.1-2.5-.2-2.8-1.4Z"
              fill="6794dc"
            />
            <polygon points="344.4 175.1 343.4 175.1 344.4 176.6 345.2 175.8 344.4 175.1" fill="6794dc" />
            <polygon points="346.2 178.5 345.5 179.3 346.7 180.3 347.1 179.4 346.2 178.5" fill="6794dc" />
            <polygon points="355.8 179.4 355.1 180.3 357.1 181.9 357.6 181.1 355.8 179.4" fill="6794dc" />
            <polygon points="358.3 181 358.3 181.9 359.4 181.9 359.8 181 358.3 181" fill="6794dc" />
            <polygon
              points="382.9 175.1 381 175.8 376.9 175.5 375.4 176.6 374.8 178.9 373.7 182.4 374.8 182.8 374.8 185.4 376.3 185.6 376.5 181.4 377 181.9 377.8 184.7 380.4 183.3 377.8 180.3 380.7 178.9 380.5 177.9 377 179.4 375.7 177.7 376.7 176.6 378.9 176.6 381.1 177.3 382.9 175.8 382.9 175.1"
              fill="6794dc"
            />
            <path d="M387.6,173.8c-.2,0-1.5,.9-1.5,.9v2.6l1.5,1.6v-.8l-.8-1.4h1.3v-1.5h-1l.5-1.3Z" fill="6794dc" />
            <polygon points="384.9 181.4 383.5 181.9 384.2 182.9 385.7 182.9 384.9 181.4" fill="6794dc" />
            <polygon
              points="386.5 181.4 386.8 182.9 389 182.2 391 182.9 390.3 181.4 388.8 181 386.5 181.4"
              fill="6794dc"
            />
            <path d="M396.3,185.6c-.2-.2-.8-.4-.8-.4l-.7,1.3,.3,1.1,1.1-2Z" fill="6794dc" />
            <polygon points="392.1 187.1 391 187.6 391.3 189 392.1 188 392.1 187.1" fill="6794dc" />
            <polygon
              points="380.8 190.7 380 192.3 381.9 191.9 383.1 190.7 381.8 190.1 380.8 190.7"
              fill="6794dc"
            />
            <polygon
              points="400.4 178.9 397.6 182 395.9 181 395.5 178.5 393 177.6 390.8 178.5 391 179.3 392.7 180.7 394.7 180.3 395 181 392.5 181.4 393.6 183.3 395.1 182.2 400.2 184.8 401.8 187.4 400.5 189.3 403.1 189 404.9 190.5 405.2 180.7 400.4 178.9"
              fill="6794dc"
            />
            <path
              d="M372.8,173.8l-.8-1.4,.6-1.2-2.5-.3-1.6,4.4-5.6,1-1.1-1.7-.8-.2s-1.6,2.1-1.1,2.1c.4,0,2.5,5.3,2.5,5.3l5.2,.4,.7,1.1,1.8-1.1,.8-2.6,1.6-3.3,1.9-.3-1.8-1.6,.3-.7Z"
              fill="6794dc"
            />
          </g>
        </g>
        <g>
          <g>
            <polygon
              points="382.9 162.8 381.1 165.3 380.5 164.7 378.3 166.1 378.3 167.4 378.9 167.4 379.6 166.2 381.2 166.2 381.3 168.1 382.9 169 383.5 167.7 383.5 166.4 385 166.8 384.4 164 382.9 162.8"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="374.3 160.2 374.8 161.7 371.8 164.7 371.2 164.3 374.3 160.2" fill="currentColor"
              stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="375.2 157 376.5 159.4 377.5 158.7 376.9 157.4 375.2 157" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
          </g>
          <g>
            <polygon
              points="376.1 139.4 375 138.6 373.7 140.7 373.7 142.7 374.5 143.7 374.9 144.6 375.4 144.6 374.9 143.4 375.7 142.4 376.1 139.4"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <path
              d="M319.7,163.1l-.5,3.1,.8,2.7,2.1-1.2s-.1-1.5,0-1.7c.1-.2-1.4-2.4-1.4-2.4l-1-.5Z" fill="currentColor"
              stroke="#fff" stroke-width=".2"
            />
            <g>
              <polygon
                points="400.1 101.3 393.7 98.5 393.7 99.6 394.3 101.3 394.3 103.2 393.3 103.2 393.3 105.3 394.1 107.5 395.6 106.5 394.3 104.8 395.6 104.6 397.8 105.9 398.4 103 400.1 103 400.1 101.3"
                fill="currentColor" stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="395.6 107.5 394.3 108.7 394.3 110.7 394.9 113.6 394.3 116.2 392.1 116.2 391.3 118.7 389.9 119.3 387.4 119.9 385.2 122.1 385.2 123.3 383.9 124.7 385.8 128.7 387 127.7 387 124.1 385.9 123 387 122.1 390.3 121.1 391.3 122.7 392 123.8 393.3 121.7 393.3 120.5 394.8 121.1 395.6 120.4 396.7 119 397.2 120.8 398.4 118.8 397.5 117.6 396.7 114.5 397.9 113.5 397.4 109.9 395.6 107.5"
                fill="currentColor" stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="389.7 122.1 387 123.1 388.4 125.2 389.7 123.7 390.6 123.7 389.7 122.1"
                fill="currentColor" stroke="#fff" stroke-width=".2"
              />
            </g>
            <polygon
              points="330.1 139.5 328.9 138.9 329.4 138.1 331 138.6 331.9 139.7 334.9 140.2 333.5 142.1 334.5 143.3 334.6 142.6 335.2 142.1 335.8 145 336.5 144.1 336.5 142.1 337.6 142.1 337.6 140.5 339.1 136.9 341.1 135.7 339.9 134.5 339.3 133.1 337 133.4 333.5 135.7 333.9 137.2 329.8 137.3 329.4 135.4 328.4 135.4 328.4 137.9 325.7 137.6 321.8 136.6 317.4 134.5 317.8 131.9 315.5 131.2 314.6 128 311.9 127.4 309.7 128.5 310.3 128.6 309 129.9 308.7 131.7 306.2 136 304.2 135.7 302.9 137.6 305 139.7 305.6 141.4 302.8 141.9 302 142.6 302.3 142.7 303.1 143.8 305.1 143.5 303.8 144.7 302.7 144.5 305.6 147.2 307.5 146 308 144.2 308.7 149.6 310.5 154.8 312.8 159.8 316.2 165.3 317.2 165 319.4 162.2 319.9 157.7 319.9 154.2 323.6 151.3 326.1 148.5 328.3 146.7 329.5 144.9 331.1 145.2 329.4 140.8 330.1 139.5"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="326.5 135 324.9 135 324.1 134.5 321.5 133 319 132.3 317.7 132.3 317.4 134.5 321.8 136.6 325.7 137.6 328.4 137.9 328.4 135.7 327.8 135.7 326.5 135"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="314.3 125.5 312.5 123.5 310.3 122.6 309.2 120.5 307.8 120.5 307.8 121 305.9 121.9 305.8 122 305.6 122.8 307.8 124.2 307 125.3 307.3 127.4 308.3 128.1 309.7 128.5 311.9 127.4 314.6 128 314.7 128.6 315.5 128 314.3 125.5"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="335.8 145 335.2 142.1 334.6 142.6 334.5 143.3 333.5 142.1 334.9 140.2 331.9 139.7 331 138.6 329.4 138.1 328.9 138.9 330.1 139.5 329.4 140.8 331.1 145.2 331.2 145.2 332.8 143.9 334.1 143.7 334.8 145.9 335.5 146.7 335.9 144.9 335.8 145"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="346 157 344.8 155.4 345 153.2 343.2 150.5 343.9 148.8 346.2 147.1 347.8 145.2 344.9 144.4 345.4 143.6 344.5 142.1 343.1 141.6 342.3 140.8 343.5 137.8 342.1 135 340.8 135.4 341.1 135.7 339.1 136.9 337.6 140.5 337.6 142.1 336.5 142.1 336.5 144.1 335.9 144.9 335.5 146.7 336.2 147.5 337.6 148.6 337 149 337.6 149.9 338.3 149.1 339.3 151.8 338.7 153.9 339.3 154.3 342.3 152.8 342.3 151.7 344 155 345.1 157.8 345.6 160.3 345.2 162.2 345.2 163 346.5 160.2 346.3 158.9 346 157"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="330.7 135.1 329.6 136.1 329.8 137.3 333.9 137.2 333.5 135.7 333.6 135.7 332.9 135.1 330.7 135.1"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="356.5 161.5 355.8 160.2 357.9 158.5 357.2 156.5 355.8 155.8 355.8 157 354 156 351.6 156 350.6 157.5 351 159.8 352.1 161.2 352.8 162.2 353.9 162.2 354.5 161.5 356.5 161.5"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="359 153.9 355.8 151.3 355.5 150.5 354.4 149.7 354.6 147.6 355.4 146 356.9 145.4 355.2 144.6 355.2 143.4 352.8 142.6 350 143.6 349.1 143.9 350 145.3 350.6 146.4 352.6 146.4 353.3 147.5 352 148.5 352.7 149.7 354.2 150.5 355.7 152.4 357.9 153.7 357.5 154.9 357.1 156.5 357.2 156.5 357.9 158.5 355.8 160.2 356.5 161.5 354.5 161.5 353.9 162.2 354 162.2 354.7 162.3 354.2 164.8 355.1 164.6 356.9 162.1 357.8 162 360.1 160.1 360.1 157.8 359 153.9"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="378.3 117.5 377.6 118 378.8 119.8 378.4 121 379.2 122.6 381 121.1 382.8 120 381.4 116.5 380 114.5 377.3 116 378.3 117.5"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="378 107.5 378.4 108.7 376.2 108 374.1 111.2 374.1 112.2 375.4 112.6 375.4 115.6 376.1 116.5 377.2 115.8 377.3 116 380 114.5 380 114.5 379.4 113.8 378.1 113.1 378 111.9 380.3 109.5 379.8 107.4 380.9 106.1 379.7 105.4 378 107.5"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="380.1 101.1 380.9 100.3 382.8 100.6 382.5 95.8 382.8 94.5 381.8 93 380.1 93.9 379.4 95.3 377.5 95 376.8 92.6 373.7 91.4 371.8 91 369.8 88 367.4 84.6 364.9 83.8 362.5 83.8 360 84.7 359.7 85.9 360.9 86.2 360.9 87.6 360.5 89.2 360.8 91.4 359.7 92.7 358 92.6 357.5 97.1 358.6 97.1 360.3 97.1 361.2 96.2 362.9 97.8 363.3 99.1 361.6 99.4 360.2 100.5 359.5 101.8 358 102.2 356.9 103.4 355.1 103.1 353.8 103.6 353.8 104.8 355 105.4 353.4 107.9 348.2 109.6 346.8 110.6 344.7 110.6 341.7 109.2 339.5 108.8 336.9 109.2 334.5 109.2 332.8 106.5 329.9 105.1 327.3 105.1 325.8 104.2 326.2 103 325.8 101.6 324.7 100 322.9 99.7 322.1 100 320.3 97.5 319.3 98.5 318.3 100 318.8 101.3 317.8 102.3 315.5 101.9 314.8 104.8 315.5 105.4 314.3 105.8 312.4 106.1 312.4 107 313.2 107.1 313.9 109.7 313.4 110.9 311.9 110.4 308.4 110.3 304.4 109.9 304.4 110.9 301.6 110.9 301.1 112.1 301.1 113.3 302 113.9 302.5 113.1 303.3 113.9 302.6 114.5 300.7 114.1 299.7 115.1 300.1 115.8 297.8 117 298.7 118.8 298.4 120.6 299.9 121 301.3 120.5 302.3 118.8 303.3 119.2 303.3 121.7 304.4 121.7 305.9 120.1 307.8 119.7 307.8 120.5 309.2 120.5 310.3 122.6 312.5 123.5 314.3 125.5 315.5 128 314.7 128.6 315.5 131.2 317.8 131.9 317.7 132.3 319 132.3 321.5 133 324.1 134.5 324.9 135 326.5 135 327.8 135.7 328.4 135.7 328.4 135.4 329.4 135.4 329.6 136.1 330.7 135.1 332.9 135.1 333.6 135.7 337 133.4 339.3 133.1 339.9 134.5 340.8 135.4 342.1 135 343.5 137.8 342.3 140.8 343.1 141.6 344.5 142.1 345.4 143.6 344.9 144.4 347.8 145.2 347.5 145.6 348.4 145.8 348.4 144.1 350 143.6 352.8 142.6 355.2 143.4 355.2 144.6 356.9 145.4 358.4 144.9 359.6 145.3 360.1 146.9 360.9 146.8 360.9 145.4 364.4 144.2 368.6 142.4 370.5 140.1 372.2 136.7 373.7 133.9 374.5 131 372.5 130 374 128.7 372.4 127.5 373.4 126.8 370.8 123.1 369 122.4 369.4 120.3 371 118.6 372.7 118.3 372.8 117 370.7 117 369.9 116.3 369 117 368.4 118.1 367.5 118.1 367.2 116.6 366.4 116.7 365.2 115.6 365.3 114.1 366.8 114.3 367.1 112.5 368.2 112.3 369 110.3 370.7 110.7 369.9 112.6 370.5 113.6 369.9 114.4 370.4 114.8 371.3 113.9 371.7 113.2 373.9 112.1 374.1 112.2 374.1 111.2 376.2 108 378.4 108.7 378 107.5 379.7 105.4 380.3 105.7 380.9 104.8 380.1 101.1"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="352.8 93.9 347.3 94.7 343.6 93.1 339.5 93.7 337.6 91.4 333.1 90.6 331.9 92.3 333.1 95.2 329.4 95.6 326.3 93.9 323.5 94.6 321.5 97 320.6 97.9 322.1 100 322.9 99.7 324.7 100 325.8 101.6 326.2 103 325.8 104.2 327.3 105.1 329.9 105.1 332.8 106.5 334.5 109.2 336.9 109.2 339.5 108.8 341.7 109.2 344.7 110.6 346.8 110.6 348.2 109.6 353.4 107.9 355 105.4 353.8 104.8 353.8 103.6 355.1 103.1 356.9 103.4 358 102.2 359.5 101.8 360.2 100.5 361.6 99.4 363.3 99.1 362.9 97.8 361.2 96.2 360.3 97.1 358.6 97.1 357.5 97.1 358 92.8 354.9 92 352.8 93.9"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <g>
              <polygon
                points="337.6 157.4 336.9 158.3 336.5 161.8 337 162.2 337 160.5 337.6 158.9 337.6 157.4"
                fill="currentColor" stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="338.2 164.7 339 167.7 339.5 167.3 338.8 165.3 338.2 164.7" fill="currentColor"
                stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="368.5 175.3 370.1 170.9 372.6 171.2 373.2 170.2 374.8 169.5 371 166.8 367.3 170.7 364.4 173.2 363.3 175 361.8 174.7 362.9 176.3 368.5 175.3"
                fill="currentColor" stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="353.9 174.4 353.3 174.4 353.1 175 349.9 173 348.6 171 348 168.3 347.6 167.8 350.8 168 350.8 168 352.6 169.9 352.7 172.6 353.9 174.4"
                fill="currentColor" stroke="#fff" stroke-width=".2"
              />
            </g>
            <polygon
              points="357.9 153.7 355.7 152.4 354.2 150.5 352.7 149.7 352 148.5 353.3 147.5 352.6 146.4 350.6 146.4 350 145.3 349.1 143.9 348.4 144.1 348.4 145.8 347.5 145.6 346.3 147.1 347.4 148.8 348.1 148.8 348.1 151.3 350.1 150.7 351.2 151 351.6 150.1 353 151.3 353.4 153.2 354.8 154.3 354.4 156.3 355.8 157 355.8 155.8 357.1 156.5 357.5 154.9 357.9 153.7"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="361.5 147.5 359.3 147.5 358.3 148.4 358.9 150.1 360.1 150.1 361 149.5 361.5 148.2 361.5 147.5"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
          </g>
        </g>
        <g class="group/country">
          <polygon
            points="251.1 125.6 251.7 126.6 253.5 126.1 254.3 125 252.7 125 251.1 125.6" fill="currentColor"
            stroke="#fff" stroke-width=".2"
          />
          <rect x="282.3" y="158.8" width="1.6" height=".8" fill="currentColor" stroke="#fff" stroke-width=".2" />
          <polygon
            points="256.8 123.1 263.9 122.2 267.2 122.2 267.5 121.8 266.7 120.6 266.2 118.2 266.7 117.5 265.4 117.1 265.3 115.8 264 114.7 261.7 114.3 261.6 115.2 258.7 115.6 255.1 114.7 253.3 113.9 249.9 114.5 248.6 115.7 246.7 115.5 246 116 246.2 116.6 243.6 117 242.5 117.7 242.7 118.6 243.4 118.8 243.4 120 242.7 120.4 245.3 123.1 247.9 123.8 248.9 122.8 251.4 124.2 253.3 123.6 254.4 122.7 256.2 122.7 255.9 124.1 256.8 124.4 256.8 123.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="269.2 119 269.8 118.2 268.3 117.1 266.9 115.1 266.7 115.2 264.9 115.4 265.3 115.8 265.4 117.1 266.7 117.5 266.3 118 267 117.8 267.3 118.2 267.8 117.8 269.2 119"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="273.5 115.8 272 113.6 270.6 114.7 269.1 113.7 268.7 114.1 269.4 115.2 267.5 114.6 266.9 115.1 268.3 117.1 269.8 118.2 269.2 119 267.8 117.8 267.3 118.2 268.4 119.3 269.8 119.2 271.4 117.8 272.2 119 272.2 119.8 272.7 120.1 273.1 117.1 274.1 116.3 273.5 115.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="256.6 129.3 256.2 128.5 255 128.7 254.8 129.4 253.6 131.2 255.3 135 255.5 134.1 255.9 129.9 256.6 129.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="255.5 126 255 128.7 256.2 128.5 256.3 128.7 257.1 126.9 255.5 126" fill="currentColor"
            stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="258.3 134.1 259.2 134.1 260.1 132.7 258.5 131.2 261.2 130.1 260.2 128.1 257.6 129.9 256.5 129.4 255.9 129.9 255.5 134.1 255.5 134 255.5 134.7 257.1 135 258.3 134.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="263.1 124.2 263.1 123.4 264.5 122.8 264.5 122.2 263.9 122.2 256.8 123.1 256.8 124.4 255.9 124.1 255.9 124.5 255.5 126 257.1 126.9 256.3 128.7 256.6 129.3 256.5 129.4 257.6 129.9 260.2 128.1 260.3 128.3 263.1 126.2 263.1 124.2"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="268.5 135 271.4 135 272 133.4 273.4 133.6 273.7 133 273.8 133 272.7 131.6 272.7 130.2 270.9 128.8 269.2 127.5 269.2 126.2 269.8 125.6 270.2 124.4 268.6 123.8 267.2 122.2 267.2 122.2 264.5 122.2 264.5 122.8 263.1 123.4 263.1 124.2 263.1 126.2 260.3 128.3 261.1 129.9 262.1 129.9 268.5 135"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="273.8 135.3 273.8 135.2 273.2 134.3 273.4 133.6 272 133.4 271.4 135 272.9 135.7 273.8 135.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="278.5 140.1 278.4 139.4 277.6 138.9 277.5 140.8 278.6 141.4 278.5 140.1" fill="currentColor"
            stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="279.2 142.1 278.7 142.1 278.6 141.4 277.5 140.8 277.5 141.1 276.2 138.2 273.8 135.3 272.9 135.7 271.4 135 271.4 135 268.5 135 262.1 129.9 261.1 129.9 261.2 130.1 258.5 131.2 260.1 132.7 259.2 134.1 258.3 134.1 257.1 135 255.5 134.7 255.5 136.3 258.3 140.1 259.4 142.2 260.6 142.5 261.6 145.1 261.8 146.6 264.4 149 266.1 151.7 266.9 153.7 268.1 153.2 268.1 151.7 272.1 152.8 272.3 154.3 274.9 151 283.9 148.5 283.9 144.1 283.9 144.1 279.2 144.1 279.2 142.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="284.9 138.6 282.4 141.8 279.2 142.1 279.2 144.1 283.9 144.1 285.6 140.5 284.9 138.6"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="274.9 151 272.3 154.3 272.1 152.8 268.1 151.7 268.1 153.2 266.9 153.7 267.3 154.5 268.6 158.9 270.7 158.5 271.5 157.6 273 158.1 274.6 157 277.2 155.8 280.7 154.8 280.7 153.5 281.7 153.2 279.7 149.6 274.9 151"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="288.6 142.7 286.2 142.2 285.6 140.5 283.9 144.1 283.9 148.5 279.7 149.6 281.7 153.2 283.6 152.5 284.7 152.3 285.1 151.4 286.2 151.1 286.7 149.9 288 149.8 288 147.9 288.8 147.1 290.4 144.6 288.6 142.7"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="294.7 137.9 293.6 135.7 292 135 290.9 133.4 292 131.7 291.7 130.4 290.4 130.4 289.3 125.8 290.1 125 289.7 122.5 283.9 119.7 280.1 121.5 280.3 122.1 276.8 122.8 272.6 121 272.7 120.1 272.2 119.8 272.2 119 271.4 117.8 269.8 119.2 268.4 119.3 267 117.8 266.3 118 266.2 118.2 266.7 120.6 267.5 121.8 267.2 122.2 268.6 123.8 270.2 124.4 269.8 125.6 269.2 126.2 269.2 127.5 270.9 128.8 272.7 130.2 272.7 131.6 273.8 133 275.9 133 277.9 136 283 138.6 285.3 137.3 286.6 139.4 292.4 140.5 292.6 140.4 292.6 138.9 294.7 137.9"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="294.1 122.8 294.7 121.3 296.8 120.8 296.8 119.7 290.8 116.8 289.8 114.5 285 111.8 283.1 113.1 283.1 114.5 281 114.5 278.6 112.8 277.1 113.7 277.5 114.8 277.6 116.5 279.3 118.2 280.1 121.5 283.9 119.7 289.7 122.5 290 124.1 292 124.7 294.1 122.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="298.7 118.8 297.8 117 300.1 115.8 299.7 115.1 300.7 114.1 302.6 114.5 303.3 113.9 302.5 113.1 302 113.9 301.1 113.3 301.1 111.8 299 114.1 296 113.9 295.7 112.8 294.3 112.4 294.3 111 293.2 109.7 288.8 109.7 286.4 108.3 286 109.2 284 108.7 284 107 280.4 107.7 281.6 114.5 283.1 114.5 283.1 113.1 285 111.8 289.8 114.5 290.8 116.8 296.8 119.7 296.8 120.5 298.3 121 298.7 118.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="298.2 131.5 301.5 129.9 302.2 126.6 303.6 126 303.9 122.5 305.9 121.9 307.8 121 307.8 119.7 305.9 120.1 304.4 121.7 303.3 121.7 303.3 119.2 302.3 118.8 301.3 120.5 299.9 121 298.4 120.6 298.3 121 296.8 120.5 296.8 120.8 294.7 121.3 294.1 122.8 292 124.7 290 124.1 290.1 125 289.3 125.8 290.4 130.4 291.7 130.4 292 131.7 290.9 133.4 298.2 133.4 298.2 131.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="305.6 141.4 305 139.7 302.9 137.6 304.2 135.7 306.2 136 308.7 131.7 309 129.9 310.3 128.6 308.3 128.1 307.3 127.4 307 125.3 307.8 124.2 305.6 122.8 305.8 122 303.9 122.5 303.6 126 302.2 126.6 301.5 129.9 298.2 131.5 298.2 133.4 290.9 133.4 292 135 293.6 135.7 294.7 137.9 292.6 138.9 292.6 140.4 297 140.1 299.2 140.1 300.7 142.2 302 142.6 302.8 141.9 305.6 141.4"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <path
            d="M317.8,97l-1.4-.5-2.3-2.1-2.1,.8h-2.1c0-.1-6.1-7-6.1-7l-2.5,1.9-4.8-1-.4-1.9-2.5-.3-1.6,1.3-6.3,2.5-1.6,.5,1.6,1.4h-1.1l-.5,2.1,1.6,1.3v1.3l-2.7,.3-2.4-.7-3.3,.7-3.4-1.6h-1.9l-2.1,2.2v1.6l-1.7-1.3-.7,1v3c.1,0,2.8,2.5,2.8,2.5l1.3,1,1.8-1.5h2.8s.7,2.8,.8,3c.1,.2-2.7,.3-2.7,.3l-.9,1.5,1.2,1.7,2.1,1,.6,1.8,1.5-.8,2.4,1.7h.5l-1.1-6.8,3.5-.7v-.7l2.4-1.2,.7,2.1-.6,1.2,2.4,1.4h4.4l1.1,1.2v1.5l1.3,.3,.3,1.2h3c0,.1,2.1-2.2,2.1-2.2v.3l.5-1.1h2.8v-1l3.9,.3h3.5c0,0,1.5,.7,1.5,.7l.5-1.2-.8-2.6h-.8v-1l1.9-.3,1.1-.4-.6-.6,.6-2.9,2.4,.4,1-1-.5-1.3,1-1.4,.6-.6-.7-1.1h-1.4Zm-13.3,8v1.7l-1.2-.6v-1.6l1.2-1.2,1.2,.4-1.2,1.3Z"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="242.9 114.8 242.1 116.5 242.5 117.1 244.1 116.1 245.5 115.9 245.6 115.4 244.6 114.7 244.4 114.1 242.8 114.8 242.9 114.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
        </g>
        <g>
          <polygon
            points="225.5 90.2 225.5 91.1 226 91.3 226 90.5 225.5 90.2" fill="currentColor" stroke="#fff"
            stroke-width=".2"
          />
          <polygon
            points="228.1 86.6 227.7 88.8 228.1 88.9 228.5 86.6 228.1 86.6" fill="currentColor" stroke="#fff"
            stroke-width=".2"
          />
          <path
            d="M230.7,85.3c-.1,0-.8,.2-.8,.2l-.5,.8,.2,1.3h.3l.6-1.1,.2-1.1Z" fill="currentColor" stroke="#fff"
            stroke-width=".2"
          />
          <polygon
            points="234.7 82.7 234 83.1 234.7 83.3 235.1 83 234.7 82.7" fill="currentColor" stroke="#fff"
            stroke-width=".2"
          />
          <polygon
            points="235.1 83.7 234.4 83.7 234 84 234 84.5 234 85.3 234.3 85.1 234.6 84.5 235.1 84.5 235.1 84.2 235.1 83.7"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="231 79.4 230.7 80.1 231.6 80.7 231.6 79.7 231 79.4" fill="currentColor" stroke="#fff"
            stroke-width=".2"
          />
          <polygon
            points="199.8 75.6 199.2 75.8 199.5 76.6 199.8 77.9 200 77.9 200 76.4 199.8 75.6" fill="currentColor"
            stroke="#fff" stroke-width=".2"
          />
          <path
            d="M183.7,67l-1.4-1.7-1.2,.9s-1.4,1.5-1.2,1.6c.2,0,2.7,0,2.7,0l-.3,1h-2.2l.3,1h1.4l.8,1-1.2,.3,.4,1h1.9l2.1,.8,5-2.2,1.1-1.6-.5-2.4-1.6-1.4-2.9,1.2-2.1-.2v1.6c0,0-1.2,.3-1.2,.3v-1.2Z"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="224.1 82.2 223.2 81.9 222.4 84.5 224.1 84 224.1 82.2" fill="currentColor" stroke="#fff"
            stroke-width=".2"
          />
          <g>
            <polygon
              points="206.5 79.3 205.8 79.7 205.8 80.3 206.3 80.5 206.5 79.9 206.5 79.3" fill="currentColor"
              stroke="#fff" stroke-width=".2"
            />
            <path
              d="M203.8,84h-2l-.4,1.6-.5,.8v.8l-.7,.7,.2,.9,1-1.2-.4,1.4v1.4c-.1,0,.5,0,.5,0l.4-1.6v1.3l-.4,1.3h.7l1.3-.4s-.4,.9-.4,1c0,.1,.2,.6,.2,.6h.8l-.3,1.7-1.7-.2-.2,1.3,.7,.2v.8c0,0-1.4,.6-1.4,.6l.2,.7,1-.2,.7,.4,.7,.2,1.1-.8-.7,1.2h-1.5l-.6,.5-1.5,1.5,.7,.3,1.3-.8,.8,.2,.8-1s1.2,0,1.3,0c.1,0,3.1-.2,3.1-.2l1.3-1.2-1.2-.3,1.3-1.6-.4-1.2h-1.8l.2-.7-.4-.6-.8-1.7-.4-.2-.9-1.7-1.1-1.1h-1.3l1.1-.4v-.5c-.1,0,1-2.1,1-2.1l-1.1-.3-1.4,.3v-.8c0,0,1-.6,1-.6v-.7Z"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="200.4 84.5 199.4 84.7 199.4 85.5 198.9 85.9 199 87.5 199.2 87.4 199.3 86 200 85.3 200.4 84.5"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <path
              d="M200.2,85.8s-.7,.2-.6,.3c.2,.1,.6,.9,.6,.9h.3v-.4l-.3-.8Z" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="202.4 92.2 201.8 92.5 201.8 93.3 202.4 92.8 202.4 92.2" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="198.4 92.2 198.9 92.8 199.3 92.2 200.1 93 200.9 92.5 200.6 90.9 199.7 90.8 199.4 90.7 198.4 91.7 198.4 92.2"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="199.3 92.2 198.9 92.8 198.4 92.2 198.4 91.7 199.4 90.7 198.3 90.5 197.5 91.5 198 91.9 197.5 92.2 195.6 92.2 195.6 93 196.1 93.3 195.6 93.9 196.7 94.4 195.6 95.5 196.9 95.5 195.6 96 194.8 96.2 195.4 97.3 196.4 97.8 197.8 97 199.6 96.5 200 96.4 200.2 95.1 200.1 93.6 200 93 200.1 93 199.3 92.2"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
          </g>
          <polygon
            points="198.9 120.6 198.6 120.4 198.9 119.3 198.4 118.2 199.1 118 199.9 114.7 196.7 114.3 196.8 114.5 196.8 116.8 195.6 119.4 196.3 120.3 196.2 122.5 198.5 122.5 198.3 121.7 198.9 120.6"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <g>
            <g>
              <polygon
                points="210.3 119.3 209.8 119.5 210 120.1 210.5 119.7 210.3 119.3" fill="currentColor"
                stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="211.2 118.6 211.8 119 212.2 118.4 211.7 118.2 211.2 118.6" fill="currentColor"
                stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="212.5 117.8 213.1 117.8 213.4 118.2 212.8 118.2 212.5 117.8" fill="currentColor"
                stroke="#fff" stroke-width=".2"
              />
            </g>
            <g>
              <polygon
                points="184.2 135.4 184.2 135.7 184.2 136.2 184.5 135.8 184.2 135.4" fill="currentColor"
                stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="185 136.2 185.3 136.8 186.3 136.5 186.3 135.8 185 136.2" fill="currentColor"
                stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="187.2 136.5 186.8 136.5 186.8 137.2 187.5 136.9 187.2 136.5" fill="currentColor"
                stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="188.5 136.8 189.1 136.8 189.5 135.8 189 135.8 188.5 136.8" fill="currentColor"
                stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="190.1 135.1 189.8 135 189.5 135.5 190.1 135.5 190.1 135.1" fill="currentColor"
                stroke="#fff" stroke-width=".2"
              />
              <polygon
                points="183.7 137.4 184.2 137.4 183.9 136.9 183.7 137.4" fill="currentColor" stroke="#fff"
                stroke-width=".2"
              />
            </g>
            <polygon
              points="208.8 113.4 206.6 112.9 205.9 112.2 197.8 111.4 196.1 112.5 196.7 114.3 199.9 114.7 199.1 118 198.4 118.2 198.9 119.3 198.6 120.4 198.9 120.6 198.3 121.7 198.5 122.5 199.2 122.5 200.6 124.2 203.1 122.9 205.5 122.9 207.2 122.2 208.1 119.6 207.6 118.4 209.8 115.8 211.7 115 211.8 113.9 210.1 113.4 208.8 113.4"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
          </g>
          <g>
            <polygon
              points="219.7 112.6 218.7 113.6 219.2 115.5 219.7 115.5 219.7 112.6" fill="currentColor"
              stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="216.7 108.9 216.3 106.9 215.2 107.5 215.4 106.5 216.4 105.4 216.3 104.7 217.3 104.7 217.8 102.2 215.7 101.6 213.4 100.7 212.2 99.8 211.3 98.5 210.7 98.8 209.9 100.5 208.9 100.8 208.1 101.7 206.9 101.7 205.9 101.1 206.1 102.9 204.8 103 201.6 103 205.5 106 206.9 108.3 205.9 112.2 205.9 112.2 206.6 112.9 208.8 113.4 210.1 113.4 211.8 113.9 212 112.6 212.8 111.7 214.3 111.9 215.7 112.6 217.5 111.3 216.2 109.3 216.7 108.9"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
          </g>
          <g>
            <polygon
              points="220.2 90.2 219.5 90.5 220.2 91.3 220.8 90.9 220.2 90.2" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="221.5 89.5 221.1 90 221.3 90.6 222 90.8 222 91.5 221.3 91.3 220.8 91.5 221.2 91.9 222.4 91.9 222.4 90.8 222.7 90.5 222.7 89.1 221.8 89.3 222 89.9 221.5 89.5"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <path
              d="M219,90.7l1.2-1,.3-4.4-3.2,2.6,.7,3.1c.6,.2,1.3,.3,1.7,.4l-.5-.7Z" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
          </g>
          <polygon
            points="211.3 98.5 212.2 99.8 213.4 100.7 214.7 101.2 215 100 215 98.5 215 98.4 212.5 97.7 211.3 98.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="214.7 101.2 215.7 101.6 215.8 101.6 214.9 100.1 214.7 101.2" fill="currentColor" stroke="#fff"
            stroke-width=".2"
          />
          <polygon
            points="221.5 81.2 222.4 80.5 221.8 78.7 222.7 77.2 221.7 76.4 221.5 72.1 223 71.6 223.8 67.1 224.8 66.1 225.7 64.1 225.5 63.2 226.4 61.5 227.2 61.7 227.6 60.3 229.4 60.7 230.7 58.3 232.4 59.9 235.5 58.9 235.7 56.5 237.2 55.9 238.6 56.9 239.2 58.4 240.9 56.7 238.7 56 240.6 55 236.7 53 230.6 55.1 225.4 59.7 220.7 69.9 217.5 73.6 213.3 76.2 214 84 216.4 85.1 220.3 82 220.7 83 221.8 83 221.5 81.2"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="233.6 62.7 233.2 61 231.6 60.3 230.3 59.1 229.4 60.7 227.6 60.3 227.2 61.7 226.4 61.5 225.5 63.2 225.7 64.1 224.8 66.1 223.8 67.1 223 71.6 221.5 72.1 221.7 76.4 222.7 77.2 221.8 78.7 222.4 80.5 221.5 81.2 221.8 83 220.7 83 223.6 90.5 227.5 88.2 227.6 83.7 229.4 82.7 229.7 80.3 228 78.7 227.8 75.1 231.9 71 232.2 67.8 234.8 67.6 234.1 65.3 233.6 62.7"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="242.9 72.7 241.7 68.8 241.7 67 240.2 63.7 240.8 62.3 238.7 59.5 239.2 58.2 238.6 56.9 237.2 55.9 235.7 56.5 235.5 58.9 232.4 59.9 230.7 58.3 230.3 59.1 231.6 60.3 233.2 61 233.6 62.7 234.1 65.3 234.8 67.6 235.9 67.5 235.9 69.1 231.9 73.8 232.5 79 235.5 80.5 240.9 78.9 240.9 78.9 243.8 73.9 242.9 72.7"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="236.6 88.3 234.6 88.1 233.5 88.8 233.5 89.1 235.5 90.7 235.6 91.6 235.4 91.6 236.9 93.2 239.5 91.9 240.6 89.5 238.4 88.4 236.6 88.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="240.1 86.1 241.4 85.7 241.3 84.8 240.7 81.6 240.7 81.6 237.2 81.4 235.5 82.5 235.9 84 237 84.1 237 85 238.7 84.8 240.1 86.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="241.9 88.2 241.4 85.7 240.1 86.1 238.7 84.8 237 85 237 86.5 236 86.6 234.9 85.3 233.5 86.9 233.5 88.8 234.6 88.1 236.6 88.3 238.4 88.4 240.6 89.5 240.6 89.4 241.9 88.2"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <g>
            <polygon
              points="224.1 121.6 227.5 123.8 228.2 121.2 224.1 121.6" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="220.3 119.2 218.7 119.8 218.7 116.3 220.3 115.8 220.3 119.2" fill="currentColor"
              stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="226.6 124.4 227.1 125.2 227.4 124.6 226.6 124.4" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="222.9 105.7 221.3 105.9 220.5 107.1 219.5 107.1 219.2 107.7 218.3 106.8 217.8 107.8 216.8 107.8 216.5 108 216.7 108.9 216.2 109.3 217.5 111.3 218.9 110.3 220.7 110.8 221.7 112.8 224.1 115.2 227.1 116.6 228.4 117.8 228.9 119.7 228.6 121.3 229.3 121.4 230.4 119 229.5 118.1 230.2 117 231.7 118.1 232.1 117 228.5 115.1 228.9 114.5 226.5 113.7 225.2 111.7 223.6 110.3 223.6 108.4 224.8 108.2 225.3 106.6 222.9 105.7"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
          </g>
          <polygon
            points="228 108.9 228.8 109 230.5 109 232.1 109.4 232.7 109 232.1 108 231.4 108.1 229.9 107.5 228.8 107.1 227.7 107.7 227 108.5 225.2 108.8 225.5 109.6 226.7 109 227.7 111 230.2 112.7 228.2 109.7 228 108.9"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="228.9 106.2 228.6 104.6 229.4 104.6 229.4 103 226.8 102.3 226.2 103 224.9 102.8 223.9 104.2 224.1 104.9 223 104.5 220.2 105.1 220.1 105.1 219.9 105.7 221.3 106 221.3 105.9 222.9 105.7 225.3 106.6 225.3 106.7 226.6 106.9 228.9 106.2"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <g>
            <polygon
              points="239 125 239 125.7 242.8 126.2 243.1 125.6 241.1 125 239 125" fill="currentColor"
              stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="235 120.1 234.8 121.2 235.5 121.2 235 120.1" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="235.5 121.5 235.1 121.6 235.3 121.9 235.5 121.8 235.5 121.5" fill="currentColor"
              stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="233.5 118.2 233.9 119 234.2 118.8 233.8 118.2 233.5 118.2" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="238.8 119.3 239 120.2 239.8 120.6 240.2 121.5 240.8 121.2 240.2 120.9 240 120.1 239.2 119.8 239.2 119.3 238.8 119.3"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <rect x="241.3" y="122.5" width=".7" height=".5" fill="currentColor" stroke="#fff" stroke-width=".2" />
            <polygon
              points="244.6 124.2 244.9 124.7 245.6 123.8 244.6 124.2" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="244.1 124.7 244.1 125.3 243.8 125.2 244.1 124.7" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="240 123.5 240.2 123.8 240.8 123.5 240.4 123.1 240 123.5" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="242.7 121.7 243.3 121.9 243.6 121.7 243 121.5 242.7 121.7" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="241.6 119.3 242.2 119.7 242.4 119 242.4 119.7 242.9 119.7 242.7 118.8 242.3 118.8 241.6 119.3"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="240.8 117.6 240.8 118 241.3 118.2 241.3 117.5 240.8 117.6" fill="currentColor" stroke="#fff"
              stroke-width=".2"
            />
            <polygon
              points="240.6 121.7 241.1 122.1 241.5 121.9 240.8 121.5 240.6 121.7" fill="currentColor"
              stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="242.3 114.5 242.3 115.2 241.3 115.4 239.3 115.5 236.1 116.3 235.1 117.5 234.4 118.7 234.8 119.2 236 120.5 235.8 121.8 237.2 123.2 238.6 123.5 238.2 122.2 239 122.2 239 121.3 239.7 121.4 238 119.2 238.5 118.7 237.5 116.9 238.8 117.7 239.6 117.4 238.9 116.4 242 116.1 242.1 116.5 242.9 114.8 242.3 114.5"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
          </g>
          <polygon
            points="220.1 105.1 218.7 104.6 217.8 104.9 217.3 104.6 217.3 104.7 216.3 104.7 216.4 105.4 215.4 106.5 215.2 107.5 216.3 106.9 216.5 108 216.8 107.8 217.8 107.8 218.3 106.8 219.2 107.7 219.5 107.1 220.5 107.1 221.3 106 219.9 105.7 220.1 105.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="241 111.4 238 111.2 237 110.5 237 111.2 237.6 112.3 237 113.1 237.2 113.9 238.1 114.9 238.3 115.8 239.3 115.5 241.3 115.4 242.3 115.2 242.3 114.5 242.8 114.8 244.4 114.1 244 113 245 111.5 245 110.9 242.7 110.5 241 111.4"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="233.1 111.7 232.3 111.7 232.5 112.2 231.5 113.7 232.9 114.6 233.3 113.5 234.2 113.4 234.2 112.7 233.1 111.7"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="232.5 110.3 232.7 109.5 232.3 109.2 232.1 109.4 230.5 109 228.8 109 228 108.9 228.2 109.7 230.2 112.7 230.4 112.8 231.5 113.7 232.5 112.2 232.3 111.7 232.8 111.7 233 110.9 232.5 110.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="234.8 114.1 234.2 113.4 233.3 113.5 232.9 114.6 233.2 114.8 233.2 117.2 234.4 118.7 235.1 117.5 235.7 116.7 234.8 115.5 234.8 114.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="226.6 106.9 225.3 106.7 224.8 108.2 225 108.2 225.2 108.8 227 108.5 227.7 107.7 228.8 107.1 229 107.2 228.5 106.3 226.6 106.9"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="234.8 115.5 235.7 116.7 236.1 116.3 238.3 115.8 238.1 114.9 237.2 113.9 237.1 113.6 234.8 114.7 234.8 115.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="235.9 109.7 235.3 109.2 233.6 107.3 232.2 108.2 232.7 109 232.3 109.2 232.7 109.5 232.5 110.3 233 110.9 232.8 111.7 233.1 111.7 234.2 112.7 234.2 113.4 234.8 114.1 234.8 114.7 237.1 113.6 237 113.1 237.6 112.3 237 111.2 237 110.5 237.2 110.6 237 109.7 235.9 109.7"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="232.8 103.6 233.3 103.9 234.2 103.1 236 102.9 236 101.6 233.8 101.6 231 102.3 229.4 103 229.4 103.9 231.3 104.6 232.8 103.6"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="236 103 236 102.9 234.2 103.1 233.3 103.9 232.8 103.6 231.3 104.6 229.4 103.9 229.4 104.6 228.6 104.6 228.9 106.2 228.5 106.3 229 107.2 229.9 107.5 231.4 108.1 232.1 108 232.2 108.2 233.6 107.3 233.8 107.5 235.1 106.9 236 104.6 236.8 103.9 236 103"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="230.5 100.3 228.7 99.9 226.5 98.5 226.5 98.5 222.7 100 223.6 101.5 225 102.7 224.9 102.8 226.2 103 226.8 102.3 229.4 103 229.4 103 231 102.3 233.1 101.8 232.1 101.2 230.5 100.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="237.2 97.1 237 96.1 237.6 95.2 236.9 93.1 235.4 91.6 228.9 91.6 225.7 93 225.5 95.3 226.5 98.5 228.7 99.9 230.5 100.3 232.1 101.2 233.1 101.8 233.8 101.6 236 101.6 236 101.9 236.5 101.8 237.3 100.1 237.9 98.9 237.2 97.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="243.9 106.2 242.1 103.5 239.2 104.6 237.6 103.6 236.7 103.9 236.8 103.9 236 104.6 235.1 106.9 233.8 107.5 235.3 109.2 235.9 109.7 237 109.7 237.2 110.6 238 111.2 241 111.4 242.7 110.5 245 110.9 245 109.4 246.1 109.1 246.2 108.2 244.1 108.3 243.9 106.2"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="258.4 103.5 258.5 102.7 258.2 101.2 258.8 100.9 258.4 100.1 255.5 99.5 254.9 98.8 253 99.3 251.8 97.3 251.1 97.4 250.4 96.8 250.2 95.6 248.2 95.6 247.9 96.1 246.4 96.3 246.2 97.2 245 97.2 242.7 97.2 240 96.6 238.5 97.1 237.1 96.8 237.2 97.1 237.9 98.9 237.3 100.1 236.5 101.8 236 101.9 236 103 236.7 103.9 237.6 103.6 239.2 104.6 241.6 103.7 241.6 102.7 242.7 102.7 243.8 103.3 244.6 103.5 245.5 105.1 246.4 106.3 245.1 106.5 244.6 108 244.1 108 244.1 108.3 246.2 108.2 246.2 108 248.1 105.8 250 106.9 251.1 107.3 249.9 108.3 251.1 108.7 251.3 109.7 254.8 108.7 254.8 107.7 252.9 108 251.6 106.9 253.2 106.1 255.1 105.4 257 104.8 257.3 103.8 258.4 103.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="245.1 106.5 246.4 106.3 245.5 105.1 244.6 103.5 243.8 103.3 242.7 102.7 241.6 102.7 241.6 103.7 242.1 103.5 243.9 106.2 244.1 108 244.6 108 245.1 106.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
        </g>
        <g>
          <polygon
            points="220.1 171.4 219.4 172.4 220.1 172.8 220.1 171.4" fill="currentColor" stroke="#fff"
            stroke-width=".2"
          />
          <rect x="216.8" y="176.3" width=".5" height=".5" fill="currentColor" stroke="#fff" stroke-width=".2" />
          <polygon
            points="276.2 193.8 274 197.1 272.3 199 269.3 199.9 268 202 268.9 204.5 267.2 208.1 267.2 210.6 269.5 213.6 272.4 212.6 276.7 199.1 277.4 199.3 277.4 198 276.2 193.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="204.6 130.4 204 132.7 199.9 135 197.4 135.2 196.1 136.5 196.1 137.8 213.4 149.6 216.2 149.2 224.1 143.5 223.2 142.1 221.8 141.8 220.9 138.9 221.4 138.6 220.3 131.2 219.2 129.2 218.1 127.4 219.2 126.1 219.3 122.4 216.1 123.1 211.7 123.3 206.5 125.3 205.3 125.6 206.9 130.4 204.6 130.4"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="225.8 201.1 227.1 201.5 233.1 201.5 235.1 202.1 237.8 202.4 240.2 201.8 238.1 200 238.1 195 241.2 195.4 240.9 192.2 238.7 192.2 238.1 187.1 235 186.7 234.6 188.4 232 188.1 231 185.4 224.7 185.4 226.8 192.5 225.1 195.6 223.7 201.3 224.5 201.5 225.8 201.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="258.7 145.5 258.7 145.5 257 144.2 255.1 140.1 253.8 137 251.7 134 252.2 133.8 254.6 136.8 255 136.1 255.3 135 253.6 131.2 253.5 131.5 249.1 131 247.3 132.1 242 130.9 241.6 130.7 242.5 145.5 258.7 145.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="254.6 180.3 251.8 180.3 252 178.5 249 178.9 248.3 180.6 248.3 181.5 248.9 181.5 249.1 185.4 250.3 186.4 251.1 188.7 254.7 190.3 254.7 190.1 255.7 190.1 256.7 192.8 256.7 193.3 259.8 193.3 262.9 192.8 264.2 191.6 264.2 191.4 262 185.3 263.1 183.2 255.2 178.2 254.6 180.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="251.3 212.7 250.9 208.8 247.8 208.2 244.9 210.2 243.6 211.9 243 213.6 239.1 213 236.3 214.9 234.8 212.3 234.8 217 232.8 218.4 230.8 217 229.4 217.4 232.1 223.6 232 226.5 234.6 227.3 242.9 225.7 250.6 218.5 252.3 214.7 251.8 214.3 251.3 212.7"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="188.7 158.8 191.6 159.2 193.2 159.6 192.4 157.4 191.5 156.2 190.3 154.3 189.1 153.2 186.7 153.2 185.1 154 184.6 154 184.2 155.8 186.5 159.3 186.9 159.2 188.7 158.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="194 164.3 193.2 162.4 191.1 163.1 190.2 163.9 191.5 166.6 192.5 167.2 193.2 166.4 194 164.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="204.2 166.6 205.1 164.4 204.6 162.7 203.2 162.7 201.2 161.8 199.4 161.8 197.2 162.3 197.6 165 196.6 167.2 196.6 168 198.1 168.5 198.1 170.7 202.3 169.3 204.3 169.9 204.5 168.8 204.2 166.6"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="196.1 136.5 197.4 135.2 199.9 135 204 132.7 204.6 130.4 206.9 130.4 205.3 125.6 204.5 125.7 201.8 125.7 200.9 124.7 200.3 124.9 199.6 127.3 196.3 129.4 195 133.5 192.6 136.4 190.5 137.5 196.1 137.4 196.1 136.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="190.5 143.5 192.1 143.5 192.1 139.8 196.1 139.8 196.4 138 196.1 137.8 196.1 137.4 190.5 137.5 190.5 137.5 189.8 138.6 186.1 144.1 185.2 146.4 190.5 146.4 190.5 143.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="192.6 154.3 193.5 155 194.9 154.3 196.4 155 200.8 155 201.2 153.7 200.8 153.2 199.9 141.4 201 141.1 196.4 138 196.1 139.8 192.1 139.8 192.1 143.5 190.5 143.5 190.5 146.4 185.2 146.4 184.9 147 186 148.1 184.6 154 185.1 154 186.7 153.2 189.1 153.2 190.3 154.3 191.4 156.1 192.6 155.4 192.6 154.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="242.5 145.5 241.6 130.7 238.8 129.7 235.6 129.6 234.5 131 235 132.1 233.7 133.5 230.6 131.9 228.8 131.7 228.2 129.8 223.3 128.8 222.5 130.7 221.6 131.1 221.6 132.6 221 133.4 220.6 133.2 221.4 138.6 220.9 138.9 221.8 141.8 223.2 142.1 224.1 143.5 227 144.4 230 143.3 241 149 242.5 148.4 242.6 145.5 242.5 145.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="221.6 132.6 221.6 131.1 222.5 130.7 223.3 128.8 223.3 128.8 221.2 127.4 222.6 126 222.3 124.9 221.6 124.2 222.4 122.7 221.3 122.9 220.7 122.2 219.3 122.4 219.2 126.1 218.1 127.4 219.2 129.2 220.3 131.2 220.6 133.2 221 133.4 221.6 132.6"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="260.3 155.8 260.8 156.5 262.2 156.1 263.6 156.5 265.8 158.2 267 159.6 268 159.3 268 159.2 264.4 155.7 262.8 155.1 261.4 151.5 259.6 152.3 259 154.2 259 156.5 259.6 156.5 260.3 155.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="268.6 163.9 267.6 161.7 267.8 161.4 266.2 161.8 266.6 160.5 266.8 159.4 265.8 158.2 263.6 156.5 262.2 156.1 260.8 156.5 260.3 155.8 259.6 156.5 259 156.5 259 156.7 258.3 158 256.6 161.3 255.5 164.7 254.3 165.3 254.7 166 255.7 166.7 257.5 169.4 258.3 170.6 260.3 170.6 261.6 171.4 263.4 172.1 264.9 170.4 266.9 171 269.2 169.9 271.4 169.7 275.2 165.5 268.6 163.9"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="270 162.5 268.2 160.7 267.6 161.7 268.6 163.9 275.2 165.5 271.4 169.7 269.2 169.9 266.9 171 266.5 170.9 265.3 172.1 265.3 177.9 266.2 179 273.2 172.3 277.7 165.7 279.2 160 270 162.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="265.3 172.1 266.5 170.9 264.9 170.4 263.4 172.1 261.6 171.4 260.3 170.6 258.3 170.6 257.5 169.4 257.2 169 255.5 170.7 257 173.9 256.2 175.3 255.2 176.6 255.7 176.6 255.2 178.2 263.1 183.2 264.7 180.5 266.2 179 265.3 177.9 265.3 172.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="251.3 173.3 250.6 175.3 249.2 177.7 249.2 178.8 252 178.5 252.3 176.6 255.2 176.6 256.2 175.3 257 173.9 255.6 170.8 251.3 171.4 251.3 173.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="254.7 192.3 254.2 193.9 253.7 195.8 254.2 197.2 255.7 197.8 255.2 199.3 256.2 201.4 257.4 199.5 257.4 197.3 256.7 196.2 256.7 196.9 255.7 196.9 255.2 193.8 254.7 190.3 253.7 189.9 253.7 190.7 254.7 192.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="245.8 207.3 245.5 205.8 244 204.6 242.5 202.4 239.8 202.4 236.8 203 236.8 207.8 235.2 208.2 235.2 213 236.3 214.9 239.1 213 243 213.6 243.6 211.9 244.9 210.2 247.7 208.2 247.3 207.3 245.8 207.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="252.3 206.3 253.1 204.5 253.1 200.5 249.9 199.5 249.9 198.8 247.8 199.2 247.4 200.1 244.7 202.4 242.7 201.8 242.5 202.4 242.5 202.4 244 204.6 245.5 205.8 245.8 207.3 247.3 207.3 247.7 208.2 247.8 208.2 250.9 208.8 250.9 208.8 252.3 207.3 252.3 206.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="240.2 201.8 237.8 202.4 235.1 202.1 233.1 201.5 227.1 201.5 225.8 201.1 224.5 201.5 223.7 201.3 223.6 201.6 226 206.1 227.4 211.7 229.3 217.4 229.4 217.4 230.8 217 232.8 218.4 234.8 217 234.8 212.3 235.2 213 235.2 208.2 236.8 207.8 236.8 203 239.8 202.4 242.5 202.4 242.6 202.1 239.9 201.6 240.2 201.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="232.8 171.4 231.3 172.1 230.2 174.4 226.4 174.1 226.5 175.2 227.8 174.8 228.2 176.1 227.1 177.1 228 177.8 227.1 180.3 225.5 179.6 223.7 180.3 224.7 180.7 224.7 181.5 223.4 182.3 224.1 183.3 224.3 184 226 183.5 226.1 183.3 226.6 183.3 227.9 183.3 228.4 183.7 230.2 182.2 230.2 180.3 232.5 178.2 233 174.3 234.1 172.1 232.8 171.4"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="224.6 184.9 225.4 184.9 226 183.5 224.3 184 224.6 184.9" fill="currentColor" stroke="#fff"
            stroke-width=".2"
          />
          <polygon
            points="223.6 173.9 221.2 173.9 220.8 175.6 223.6 175.6 223.6 173.9" fill="currentColor" stroke="#fff"
            stroke-width=".2"
          />
          <polygon
            points="224.7 180.7 223.7 180.3 225.5 179.6 227.1 180.3 228 177.8 227.1 177.1 228.2 176.1 227.8 174.8 226.5 175.2 226.4 174.1 224.1 173.9 223.6 173.9 223.6 175.6 220.8 175.6 220.1 178.2 223.4 182.3 224.7 181.5 224.7 180.7"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="250.6 172.1 249.5 170.3 247.1 170.7 246.1 169.6 243.1 169.9 239.2 170.1 239.2 171.1 237 170.8 235.2 169.5 234.1 170.7 233.6 171.8 234.1 172.1 233 174.3 232.5 178.2 230.2 180.3 230.2 182.2 228.4 183.7 227.9 183.3 226.1 183.3 225.4 184.9 224.6 184.9 224.7 185.4 231 185.4 232 188.1 234.6 188.4 235 186.7 238.1 187.1 238.7 192.2 240.9 192.2 241 193.1 242.3 192.8 244.1 193.8 245.7 193.5 247.8 195.4 249.2 195.8 249.2 193.9 248 193.9 247.2 192.8 247.8 190.6 247.3 189.7 249.8 188.1 248.3 185.6 247.8 181.5 248.3 181.5 248.3 180.6 249 178.9 249.2 178.8 249.2 177.7 250.6 175.3 251.3 173.3 251.3 172.1 250.6 172.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="245.6 169 243.3 166.6 242.1 165.3 240.5 163.9 239.5 161.1 239.5 161 237.9 162.4 237 163.9 234.1 163.9 234.5 165.3 231.9 166.2 230.3 166.6 229.5 166.1 228.7 167.9 228.4 169.2 229.3 171.4 230.7 173.3 231.3 172.1 232.8 171.4 233.6 171.8 234.1 170.7 235.2 169.5 237 170.8 239.2 171.1 239.2 170.1 243.1 169.9 246.1 169.6 245.6 169"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="189.2 158.9 188.7 158.8 186.9 159.2 186.5 159.3 187.8 161.4 187.9 161.5 189.5 160.6 189.2 158.9"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="195.7 166.2 195.7 165.3 194.9 164.8 193.8 164.8 193.2 166.4 192.5 167.2 198 170.7 198.1 170.7 198.1 168.5 196.6 168 196.6 167.2 197 166.2 196.6 166.2 195.7 166.2"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="196.4 159.6 195.4 159.4 194 159.9 193.1 159.4 193.2 159.6 191.6 159.2 189.2 158.9 189.5 160.6 187.9 161.5 190.2 163.8 190.2 163.9 191.1 163.1 193.2 162.4 194 164.3 193.8 164.8 194.9 164.8 195.7 165.3 195.7 166.2 196.6 166.2 197 166.2 197.6 165 197.2 162.3 198.2 162.1 196.6 161 196.4 159.6"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="222.2 167.1 223.6 167.8 224.6 166.2 226.6 162.9 228 160.6 227.7 158.7 226.7 157.7 225.5 158.4 223.7 158 221.2 158.9 219.4 158 217.9 158.5 216.8 157.4 213.9 157.6 213.2 160 213.9 161.8 212.5 163.8 212.5 167.8 212.9 167.6 215.8 170.7 219.9 170.3 220.6 168.4 222.2 167.1"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="229.3 171.4 228.4 169.2 228.7 167.9 229.7 165.8 228.2 164 227.6 162.9 229.7 162.9 228.8 161.8 228.8 159.6 227.7 158.7 228 160.6 226.6 162.9 224.6 166.2 223.6 167.8 222.2 167.1 220.6 168.4 219.9 170.3 220.2 170.3 221.5 172.6 221.2 173.9 224.1 173.9 230.2 174.4 230.7 173.3 229.3 171.4"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="210.1 158.7 209.9 157.4 208.7 156.8 209 155.6 207.3 155.6 204.2 157.4 202.9 157.4 201.2 160.2 200.9 161.8 201.2 161.8 203.2 162.7 204.3 162.7 204.6 161 208.1 161 209.6 161 211.4 160 212.1 159.5 211.2 158.3 210.1 158.7"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="209 164.8 209 162.4 208.2 161 208.1 161 204.6 161 204.3 162.7 204.6 162.7 205.1 164.4 204.2 166.6 204.5 168.8 204.3 169.9 205.6 170.3 209.9 168.7 209 167.2 209 164.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="213.2 160 213.3 159.6 212.5 159.2 211.4 160 209.6 161 209.4 161 210.4 162.2 210.8 164 210.4 167.1 210.9 168.3 212.5 167.8 212.5 163.8 213.9 161.8 213.2 160"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="210.8 164 210.4 162.2 209.4 161 208.2 161 209 162.4 209 164.8 209 167.2 209.9 168.7 210.9 168.3 210.4 167.1 210.8 164"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="213.9 154.5 214.2 151.7 214.2 149.5 213.4 149.6 201 141.1 199.9 141.4 200.8 153.2 201.2 153.7 200.8 155 196.4 155 194.9 154.3 193.5 155 192.6 154.3 192.6 155.4 191.4 156.1 191.5 156.2 192.4 157.4 193.1 159.4 194 159.9 195.4 159.4 196.4 159.6 196.6 161 198.2 162.1 199.4 161.8 200.9 161.8 201.2 160.2 202.9 157.4 204.2 157.4 207.3 155.6 209 155.6 209 155.7 210.7 155.6 213.9 154.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="239.9 154.6 241.2 154.6 240.8 148.9 230 143.3 228.3 143.9 229 145.5 229.1 146.6 229.8 147.8 229.3 149.6 229.3 153.2 226.6 155.8 226.6 157.7 226.7 157.7 228.8 159.6 228.8 161.8 229.7 162.9 227.6 162.9 228.2 164 229.7 165.8 229.5 166.1 230.3 166.6 231.9 166.2 234.5 165.3 234.1 163.9 237 163.9 237.9 162.4 239.5 161 238.4 158.9 238.8 157.4 239.9 154.6"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="229.3 153.2 229.3 149.6 229.8 147.8 229.1 146.6 229 145.5 228.3 143.9 227 144.4 224.1 143.5 224.1 143.5 216.2 149.2 214.2 149.5 214.2 151.7 213.9 154.5 210.7 155.6 209 155.7 208.7 156.8 209.9 157.4 210.1 158.7 211.2 158.3 212.1 159.5 212.5 159.2 213.3 159.6 213.9 157.6 216.8 157.4 217.9 158.5 219.4 158 221.2 158.9 223.7 158 225.5 158.4 226.6 157.7 226.6 155.8 229.3 153.2"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="254 196.7 253.7 195.8 254.2 193.9 254.7 192.3 253.7 190.7 253.7 189.9 251.1 188.7 251.3 189.3 250.4 189.3 249.8 188.1 247.3 189.7 247.8 190.6 247.2 192.8 248 193.9 249.2 193.9 249.2 195.8 247.8 195.4 245.7 193.5 244.1 193.8 242.3 192.8 241 193.1 241.2 195.4 238.1 195 238.1 200 239.9 201.6 242.6 202.1 242.7 201.8 244.7 202.4 247.4 200.1 247.8 199.2 249.7 198.8 249.9 198.1 254 196.7"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="262.9 192.8 259.8 193.3 256.7 193.3 256.7 196.2 257.4 197.3 257.4 199.5 256.2 201.4 255.2 199.3 255.7 197.8 254.2 197.2 254 196.7 249.9 198.1 249.7 198.8 249.9 198.8 249.9 199.5 253.1 200.5 253.1 204.5 252.3 206.3 252.3 207.3 250.9 208.8 251.3 212.7 251.8 214.3 252.3 214.7 252.6 214.1 252.5 213.3 256.3 211.2 256.3 208.4 255.7 204.8 263.7 199 264.2 196.5 264.2 191.6 262.9 192.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <polygon
            points="266.2 161.8 267.8 161.4 268.2 160.7 268 160.4 268 159.3 267 159.6 266.8 159.4 266.6 160.5 266.2 161.8"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
          <g>
            <polygon
              points="261.3 151.2 259.6 149.8 258.7 145.5 242.6 145.5 242.5 148.4 241 149 240.8 148.9 241.2 154.6 239.9 154.6 238.8 157.4 238.4 158.9 239.5 161.1 240.5 163.9 242.6 162.6 246.4 162.6 248.3 162.4 250.7 161.5 253.1 158.7 255.2 161 256.6 161.3 256.6 161.3 258.3 158 259 156.7 259 154.2 259.6 152.3 261.4 151.5 261.3 151.2"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
            <polygon
              points="253.1 158.7 250.7 161.5 248.3 162.4 246.4 162.6 242.6 162.6 240.5 163.9 240.5 163.9 242.1 165.3 243.3 166.6 245.6 169 247.1 170.7 249.5 170.3 250.6 172.1 251.3 172.1 251.3 171.4 255.6 170.8 255.5 170.7 257.2 169 255.7 166.7 254.7 166 254.3 165.3 255.5 164.7 256.6 161.3 255.2 161 253.1 158.7"
              fill="currentColor" stroke="#fff" stroke-width=".2"
            />
          </g>
        </g>
        <g>
          <path
            id="Germany"
            d="M223.6,101.5l-.9-1.5,3.7-1.4-1-3.3,.2-2.2h0s-2.1-.7-2.1-.7l-3.2,.2-.9-1.1c-.4,0-1.1-.3-1.7-.4l.5,2.5-2,.6,.2,1.3-.6,.4,.3,.7-.3,.5h-.7l-.3,1.4v1.5h0c0,.1,.8,1.6,.8,1.6l2,.5-.5,2.4,.5,.3,.9-.2,1.5,.5,2.8-.5,1.1,.3-.2-.6,1.1-1.6-1.4-1.2Z"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
        </g>
        <g>
          <polygon
            id="Thailand"
            points="353.4 153.2 353 151.3 351.6 150.1 351.2 151 350.1 150.7 348.1 151.3 348.1 148.8 347.4 148.8 346.3 147.1 346.2 147.1 343.9 148.8 343.2 150.5 345 153.2 344.8 155.4 346 157 346.3 158.9 346.5 160.2 345.2 163 345.2 165.3 345.6 165.1 347.6 167.8 350.8 168 348.9 167 348 166.2 348.4 165.8 347.9 164.6 346.9 163.5 346.3 163.1 346.8 161.1 347.3 159 347.3 157.6 348.5 157.6 348.5 158.8 350.9 159.7 351 159.8 350.6 157.5 351.6 156 354 156 354.4 156.3 354.8 154.3 353.4 153.2"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          >
          </polygon>
        </g>
        <g>
          <polygon
            id="Netherlands"
            points="216.5 95.5 216.3 94.2 213.3 95.1 212.5 97.7 212.5 97.7 215 98.4 215.2 97.1 216 97.1 216.2 96.6 216 95.9 216.5 95.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
        </g>
        <g>
          <polygon
            id="Singapore" points="354 174.5 354 174.6 353.6 175.3 353.1 175 353.3 174.4 353.9 174.4 354 174.5"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
        </g>
        <g>
          <polygon
            id="Philippines"
            points="378.3 152.3 375.6 149.1 374.8 150.4 374.3 154.1 375.7 156 376.9 156.9 379 157.4 380.8 159 382 160.2 381.1 160.2 380 162.2 379.6 160.2 378.2 159.8 378.2 161.8 379.2 161.3 378.7 163.1 380 164 381.1 162.2 381.4 163.1 382.4 162.7 381.6 161.1 382.9 161.1 383.5 160.9 382.9 158.5 380.6 158.1 380 156.5 378.6 155.8 377.2 155.8 376.9 154.1 378.3 152.3"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
        </g>
        <g>
          <path
            id="Usa"
            d="M118.8,103.5l-3.7,3-6.2,2.2v.2c0,0-1,1-1,1l-1.4-.5-1.8,.5h0s-.5,.8-.5,.8l.5,.4-5.2,2.3-1-1.2,1.3-.2,.6-.4,.4-2.2h-.2l-.6-1.4-.8,.8s-.5-.5-.7-.5,1-1.2,1-1.2l.4-1.3-2-.8-1.4,.8-.9,1.6-.2,2.5-1.9,2.2-.7-.9,1.3-3.7-.4-1.4,1.8-2h3.9l-1.2-1.4-2.2,.6-1.6-1,.4-1.3-4.2,1.6-1.8-1.1,3.2-1.7-4.7-2.3-37.6-3.6,.4,.6-3.3,.3-.7,6.6-2.6,7v6.7l2.1,6.8,3.7,3.1,.3,1.2,3.3,.4,5.5,2.6h6.2l3.6,4.3,2.8-1,2.4,5.6,2.4,1,.8-4.6,5.1-1.8,3.6,.8,1.6-.8-.3-1.1,7.3,.7,2.2,1.2v2.9c-.1,0,1.6,4.1,1.6,4.1l1.5-.8,.3-3.3-1.1-6.9,7.3-4.9,1.2-7,.2-.2,.7,2.7,1.2-2-.5-2,.3-.2,.2,1.5,1.9-2.3-.3-.9,.5-.4,4.8-1.4,.4-3,4.7-2.2v-4h-2.2Z"
            fill="currentColor" stroke="#fff" stroke-width=".2"
          />
        </g>
      </g>
      
      <foreignObject  class="relative"  width="125" height="55" transform="translate(331,140) scale(0.5,0.5)">
        <div xmlns="http://www.w3.org/1999/xhtml" ref="targetTH" class="flex justify-center text-center inset-0 items-center absolute">
          <div ref="pointTH" class="bg-secondary-red-100/80 rounded-full w-[20px] h-[20px] cursor-pointer pulse">
            <div class="absolute inset-0 m-auto h-full w-full scale-100 animate-ping animate-delay-600 animate-duration-1000 border-0 rounded-full -z-1 bg-secondary-red-100/65" />
          </div>
          <div class="text-primary text-[0.7rem] font-bold text-anim ml-1">Thailand</div>
        </div>
      </foreignObject> 
      <foreignObject class="relative" width="100" height="35" transform="translate(342,165) scale(0.5,0.5)">
        <div xmlns="http://www.w3.org/1999/xhtml" ref="targetSG" class="flex justify-center text-center inset-0 items-center absolute">
          <div ref="pointSG" class="bg-secondary-red-100/80 rounded-full w-[10px] h-[10px] cursor-pointer pulse animate-delay-1000">
            <div class="absolute inset-0 m-auto h-full w-full scale-100 animate-ping animate-delay-1600 animate-duration-1300 border-0 rounded-full -z-1 bg-secondary-red-100/65" />
          </div>
          <div class="text-primary text-[0.7rem] font-bold text-anim ml-1">Singapore</div>
        </div>
      </foreignObject> 
      <foreignObject class="relative" width="125" height="22" :transform="locale === 'en' ? 'translate(206,93) scale(0.5,0.5)' : 'translate(198,93) scale(0.5,0.5)'">
        <div xmlns="http://www.w3.org/1999/xhtml" ref="targetNL" class="flex justify-center text-center inset-0 items-center absolute">
          <div ref="pointNL" class="bg-secondary-red-100/80 rounded-full w-[8px] h-[8px] cursor-pointer pulse animate-delay-1000">
            <div class="absolute inset-0 m-auto h-full w-full scale-100 animate-ping animate-delay-1500 animate-duration-900 border-0 rounded-full -z-1 bg-secondary-red-100/65" />
          </div>
          <div class="text-primary text-[0.65rem] font-bold text-anim ml-1">The Netherlands</div>
        </div>
      </foreignObject>
      <!-- <foreignObject class="relative" width="110" height="35" transform="translate(368,153) scale(0.5,0.5)">
        <div xmlns="http://www.w3.org/1999/xhtml" ref="targetPH" class="flex justify-center text-center inset-0 items-center absolute">
          <div @click="handlePH" ref="pointPH" class="bg-secondary-red-100/80 rounded-full w-[13px] h-[13px] cursor-pointer pulse animate-delay-1000">
            <div class="absolute inset-0 m-auto h-full w-full scale-100 animate-ping animate-delay-1400 animate-duration-1500 border-0 rounded-full -z-1 bg-secondary-red-100/65" />
          </div>
          <div class="text-primary text-[0.7rem] font-bold text-anim ml-1">{{ location.content.components[3].country }}</div>
        </div>
      </foreignObject> -->
      <foreignObject class="relative" width="115" height="45" transform="translate(60,100) scale(0.5,0.5)">
        <div xmlns="http://www.w3.org/1999/xhtml" ref="targetUS" class="flex justify-center text-center inset-0 items-center absolute">
          <div ref="pointUS" class="bg-secondary-red-100/80 rounded-full w-[15px] h-[15px] cursor-pointer pulse animate-delay-1000">
            <div class="absolute inset-0 m-auto h-full w-full scale-100 animate-ping animate-delay-800 animate-duration-1400 border-0 rounded-full -z-1 bg-secondary-red-100/65" />
          </div>
          <div class="text-primary text-[0.7rem] font-bold text-anim ml-1">United States</div>
        </div>
      </foreignObject>
      <foreignObject class="relative" width="86" height="28" transform="translate(215,84) scale(0.5,0.5)">
        <div xmlns="http://www.w3.org/1999/xhtml" ref="targetDE" class="flex justify-center text-center inset-0 items-center absolute">
          <div  ref="pointDE" class="bg-secondary-red-100/80 rounded-full w-[12px] h-[12px] cursor-pointer pulse animate-delay-1000">
            <div class="absolute inset-0 m-auto h-full w-full scale-100 animate-ping animate-delay-2000 animate-duration-2000 border-0 rounded-full -z-1 bg-secondary-red-100/65" />
          </div>
          <div class="text-primary text-[0.65rem] font-bold text-anim ml-1">Germany</div>
        </div>
      </foreignObject>
    </svg>
    </div>
  </div>
</template>

<style>
@media screen and (min-width: 769px) {
  .country-card {
    @apply translate-x-[-25%];
  }
}

@media screen and (max-width: 768px) {
  .country-card {
    @apply !inset-x-0 mx-auto;
  }
}

.text-anim {
  animation: text-anim 2s infinite ease-in-out alternate;
}

.pulse {
  animation: pulse 2s infinite ease-in-out alternate;
}
@keyframes text-anim {
  0% {
    transform: translateX(0)
  }
  20% {
    transform: translateX(0)
  }
  40% {
    transform: translateX(4px)
  }
  100% {
    transform: translateX(4px)
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }
  20% {
    transform: scale(0.9);
  }
  40% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1.3);
  }
}
</style>
